/* Gemaakt op 2026-05-21 16:55 - complete vervangbare versie, winkelwagenknop pas actief na stap 1 t/m 4 */
/* assets/rail-configurator-v3.js
   Rail configurator – Worker-only (opgeschoond)
   - Tekenen + segment inputs + add-to-cart + export PDF (download via Worker)
   - Alle berekeningen via Cloudflare Worker (/solve)
   - Shareable link via ?cfg=...
   - Mobile + desktop duplicate action bars supported (A)
*/
(function () {
  'use strict';

  const root = document.querySelector('[data-railcfg]');
  if (!root) return;

  // ---------------------------
  // Config + DOM
  // ---------------------------
  const WORKER_BASE = (root.dataset.workerBaseUrl || '').trim().replace(/\/+$/, '');

  const $ = (sel) => root.querySelector(sel);
  const $$ = (sel) => Array.from(root.querySelectorAll(sel));

  const el = {
    workerUrl: $('[data-worker-url]'),
    svg: $('[data-svg]'),
    partsBody: $('[data-parts]'),
    partsWrap: $('[data-parts-wrap]'),
    summary: $('[data-summary]'),

    // Buttons can exist twice (desktop + mobile) => arrays
    btnUndo: $$('[data-undo]'),
    btnClear: $$('[data-clear]'),
    btnPickPower: $$('[data-pick-power]'),
    btnClearPower: $$('[data-clear-power]'),
    btnAddCart: $$('[data-add-cart]'),
    btnOffer: $('[data-offer-btn]'),
    offerPanel: $('[data-offer-panel]'),
    offerForm: $('[id="RailcfgOfferForm"]'),
    offerSubmit: $('[data-offer-submit]'),
    offerDesignCode: $('[data-offer-design-code]'),
    offerFormMsg: $('[data-offer-form-msg]'),
    btnLocks: $$('[data-lock]'),
    btnFinishDraw: $$('[data-finish-draw]'),

    goCart: $('[data-go-cart]'),
    cartMsg: $('[data-cart-msg]'),
    designMsg: $('[data-design-msg]'),

    segTableBody: $('[data-segtable]'),
    cutPlan: $('[data-cutplan]'),
    cutPlanWrap: $('[data-cutplan-content]'),
    cutPlanToggle: $('[data-cutplan-toggle]'),
    cutPlanBlock: $('[data-cutplan-block]'),
    confidenceBlock: $('[data-confidence-block]'),

    colorBtns: $$('[data-color]'),
    colorName: $('[data-color-name]'),
    statusText: $('[data-status-text]'),
    configAlert: $('[data-config-alert]'),
    stepItems: $$('[data-step-index]'),

    btnExportPdf: $('[data-export-pdf]'),
    btnSaveDesign: $('[data-save-design]'),
    btnShareLink: $('[data-share-link]'),
    btnLoadDesign: $('[data-load-design]'),
    designCodeInput: $('[data-design-code]'),

    powerStatus: $('[data-power-status]'),
    step2Section: root.querySelector('.railcfg__flowSection--draw'),
    step3Section: $('[data-step-power-section]'),
    step4Section: root.querySelector('.railcfg__flowSection--lengths'),
    step5Section: $('[data-spots-section]'),

    // optional rails UI (sidebar)
    railsToggle: $('[data-rails-toggle]'),
    railsClose: $('[data-rails-close]'),
    railsBlock: $('[data-rails-block]'),
    railsMiniStatus: $('[data-rails-mini-status]'),
    colorCard: root.querySelector('.railcfg__card--color'),

    // optional spots carousel
    spotsSection: $('[data-spots-section]'),
    spotsColorLabel: $('[data-spots-color-label]'),
    spotTracks: $$('[data-spots-track]'),
    spotPrev: $('[data-spots-prev]'),
    spotNext: $('[data-spots-next]'),

    // optional accessories carousel
    accessoriesColorLabel: $('[data-accessories-color-label]'),
    accessoryTracks: $$('[data-accessories-track]'),

    addStrips: $('[data-add-strips]'),
    addStripsHint: $('[data-add-strips-hint]'),
    measureModeRadios: $$('[data-measure-mode-radio]'),
    measureModeChoices: $$('[data-measure-choice]')
  };

  // verplichte elementen
  const mustHaveButtons =
    el.btnUndo.length &&
    el.btnClear.length &&
    el.btnPickPower.length &&
    el.btnClearPower.length &&
    el.btnAddCart.length;

  if (!el.svg || !el.partsBody || !el.summary || !mustHaveButtons) return;

  if (el.workerUrl) el.workerUrl.textContent = WORKER_BASE || '—';

  // Store default labels so we can restore them (desktop/mobile may differ)
  el.btnPickPower.forEach((b) => {
    if (!b.dataset.defaultLabel) b.dataset.defaultLabel = (b.textContent || '').trim();
  });
  el.btnAddCart.forEach((b) => {
    if (!b.dataset.defaultLabel) b.dataset.defaultLabel = (b.textContent || '').trim();
  });
  if (el.btnExportPdf && !el.btnExportPdf.dataset.defaultLabel) {
    el.btnExportPdf.dataset.defaultLabel = (el.btnExportPdf.textContent || '').trim();
  }
  if (el.btnSaveDesign && !el.btnSaveDesign.dataset.defaultLabel) {
    el.btnSaveDesign.dataset.defaultLabel = (el.btnSaveDesign.textContent || '').trim();
  }
  if (el.btnShareLink && !el.btnShareLink.dataset.defaultLabel) {
    el.btnShareLink.dataset.defaultLabel = (el.btnShareLink.textContent || '').trim();
  }
  el.btnFinishDraw.forEach((b) => {
    if (!b.dataset.defaultLabel) b.dataset.defaultLabel = (b.textContent || '').trim();
  });

  function setDisabledAll(list, disabled) {
    (list || []).forEach((b) => { b.disabled = !!disabled; });
  }
  function setTextAll(list, text) {
    (list || []).forEach((b) => { b.textContent = text; });
  }
  function restoreDefaultText(list) {
    (list || []).forEach((b) => {
      const t = b.dataset.defaultLabel;
      if (t) b.textContent = t;
    });
  }

  const ADD_CART_INCOMPLETE_LABEL = 'Voltooi eerst stap 1 t/m 4';

  function isStepOneToFourComplete() {
    return !!(
      state.color &&
      state.segments.length > 0 &&
      state.powerKey &&
      state.measureMode &&
      state.segmentLenCm.size === state.segments.length &&
      !state.lenWarning &&
      !hasRailValidationError() &&
      state.lastParts &&
      state.lastRailParts
    );
  }

  function updateAddCartButtonState(forceDisabled) {
    const ready = !forceDisabled && isStepOneToFourComplete();

    el.btnAddCart.forEach((btn) => {
      btn.disabled = !ready;
      btn.classList.toggle('is-disabled', !ready);
      btn.setAttribute('aria-disabled', ready ? 'false' : 'true');
      btn.textContent = ready
        ? (btn.dataset.defaultLabel || 'Voeg complete set toe aan winkelmand')
        : ADD_CART_INCOMPLETE_LABEL;
    });
  }


  function bindPress(list, handler) {
    (list || []).forEach((btn) => {
      if (!btn) return;
      btn.addEventListener('click', handler);
      btn.addEventListener('touchend', (evt) => {
        evt.preventDefault();
        handler(evt);
      }, { passive: false });
    });
  }

  function getConfiguratorType() {
    const code = normalizeDesignCode(state && state.designCode ? state.designCode : '');
    if (code.startsWith('3F-')) return '3F';
    return '1F';
  }

  function countSelectedSpots() {
    let total = 0;
    try {
      for (const qty of state.spotQtyByVariant.values()) total += clampSpotQty(qty);
    } catch (e) {}
    return total;
  }

  async function trackRailcfgEvent(eventName, extra, options) {
    const event = String(eventName || '').trim();
    if (!event || !WORKER_BASE) return false;

    const waitForResponse = !!(options && options.waitForResponse);
    const segmentCount = Array.isArray(state.segments) ? state.segments.length : 0;
    const enteredLengthCount = countEnteredLengths();
    const spotCount = countSelectedSpots();

    const payload = Object.assign({
      event,
      designCode: state.designCode || null,
      configurator: getConfiguratorType(),
      color: state.color || null,
      segmentCount,
      enteredLengthCount,
      spotCount,
      // Backwards compatible aliases voor oudere/debug weergave.
      segments: segmentCount,
      enteredLengths: enteredLengthCount,
      selectedSpots: spotCount,
      pageUrl: window.location.href
    }, extra || {});

    try {
      const body = JSON.stringify(payload);
      const endpoint = WORKER_BASE + '/track';

      if (!waitForResponse && navigator.sendBeacon) {
        const blob = new Blob([body], { type: 'application/json' });
        const queued = navigator.sendBeacon(endpoint, blob);
        if (queued) return true;
      }

      const res = await fetch(endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body,
        keepalive: !waitForResponse
      });

      if (!res.ok && window && window.console && typeof window.console.warn === 'function') {
        window.console.warn('[railcfg] Tracking event niet opgeslagen:', event, res.status);
      }

      return res.ok;
    } catch (e) {
      if (window && window.console && typeof window.console.warn === 'function') {
        window.console.warn('[railcfg] Tracking event mislukt:', event, e);
      }
      return false;
    }
  }


  function parseCmInput(value) {
    if (value == null) return null;
    const normalized = String(value).trim().replace(',', '.');
    if (!/^\d+(?:\.\d)?$/.test(normalized)) return null;
    const n = Number(normalized);
    if (!isFinite(n) || n <= 0) return null;
    return n;
  }

  function formatCmValue(value) {
    const n = Number(value);
    if (!isFinite(n) || n <= 0) return '';
    if (Math.abs(n - Math.round(n)) < 1e-9) return String(Math.round(n));
    return n.toFixed(1).replace('.', ',');
  }


  function countEnteredLengths() {
    const map = getDisplayLengthMap();
    return map ? map.size : 0;
  }

  function getDisplayLengthMap() {
    if (state.measureMode === 'hart') return state.centerLenCm;
    if (state.measureMode === 'rail') return state.segmentLenCm;
    return null;
  }

  function getNodeCorrectionCm(nodeKeyStr, nodes) {
    const node = nodes.get(nodeKeyStr);
    if (!node) return 0;

    const deg = Array.isArray(node.incident) ? node.incident.length : 0;
    const isPowerNode = !!state.powerKey && nodeKeyStr === state.powerKey;

    if (isPowerNode) {
      if (deg <= 1) return 3.5;
      return 4.0;
    }

    if (deg <= 1) return 0.0;
    if (deg === 2) return isCollinearDegree2Node(nodeKeyStr, nodes) ? 0.0 : 4.0;
    if (deg >= 3) return 4.0;
    return 0.0;
  }

  function getSegmentCorrectionsCm(seg) {
    const nodes = buildNodeMapFromSegments(state.segments);
    const leftKey = pointKey(seg.a);
    const rightKey = pointKey(seg.b);
    return {
      left: getNodeCorrectionCm(leftKey, nodes),
      right: getNodeCorrectionCm(rightKey, nodes)
    };
  }

  function recomputeDerivedLengthsFromMode() {
    pruneSegmentLenMap();
    if (!state.measureMode) return;

    const existing = new Set(state.segments.map(normSegKey));
    for (const k of Array.from(state.centerLenCm.keys())) {
      if (!existing.has(k)) state.centerLenCm.delete(k);
    }

    const nextRail = new Map();
    const nextCenter = new Map();

    state.segments.forEach((seg) => {
      const key = normSegKey(seg);
      const corr = getSegmentCorrectionsCm(seg);

      if (state.measureMode === 'hart') {
        const hart = state.centerLenCm.get(key);
        if (typeof hart === 'number' && isFinite(hart) && hart > 0) {
          nextCenter.set(key, hart);
          const rail = Number((hart - corr.left - corr.right).toFixed(1));
          if (isFinite(rail) && rail > 0) nextRail.set(key, rail);
        }
      } else {
        const rail = state.segmentLenCm.get(key);
        if (typeof rail === 'number' && isFinite(rail) && rail > 0) {
          nextRail.set(key, rail);
          const hart = Number((rail + corr.left + corr.right).toFixed(1));
          if (isFinite(hart) && hart > 0) nextCenter.set(key, hart);
        }
      }
    });

    state.segmentLenCm = nextRail;
    state.centerLenCm = nextCenter;
  }

  function setMeasureMode(nextMode) {
    const mode = nextMode === 'hart' ? 'hart' : (nextMode === 'rail' ? 'rail' : null);
    if (state.measureMode === mode) return;
    state.measureMode = mode;
    recomputeDerivedLengthsFromMode();
    setDesignCode(null);
    render();
  }

  function updateMeasureModeUI() {
    (el.measureModeRadios || []).forEach((radio) => {
      radio.checked = radio.value === state.measureMode;
    });

    (el.measureModeChoices || []).forEach((choice) => {
      const radio = choice.querySelector('[data-measure-mode-radio]');
      const isActive = !!(radio && radio.value === state.measureMode);
      choice.classList.toggle('is-active', isActive);
    });
  }

  // ---------------------------
  // Variant IDs (ongewijzigd)
  // ---------------------------
  const VARIANTS = {
    black: {
      GB11: 55567811838339, GB12: 55567812198787, GB14: 55567812395395, GB41: 55567812821379,
      GB34: 55567812952451, GB35: 55567813050755, GB36: 55567842181507, GB37: 55567842476419,
      GB38: 55567847457155, GB39: 55567843459459, GB40: 55567843492227,
      GB2100: 55567811248515, GB2150: 55567937438083, GB2200: 55567811379587, GB2300: 55567811576195,
      GB21: 55567812886915,
      STRIP1000: 55572872331651, STRIP1500: 55572872364419
    },
    white: {
      GB11: 55567815311747, GB12: 55567815475587, GB14: 55567815934339, GB41: 55567815967107,
      GB34: 55567816294787, GB35: 55567816327555, GB36: 55567842312579, GB37: 55567845491075,
      GB38: 55567848014211, GB39: 55567846015363, GB40: 55567846834563,
      GB2100: 55567813345667, GB2150: 55567937864067, GB2200: 55567813476739, GB2300: 55567814754691,
      GB21: 55567816163715,
      STRIP1000: 55572871610755, STRIP1500: 55572871643523
    },
grey: {
  GB11: 55567817245059,
  GB12: 55567817441667,
  GB14: 55567817605507,
  GB41: 55567818097027,
  GB34: 55567818686851,
  GB35: 55567818785155,
  GB36: 55567842247043,
  GB37: 55567843787139,
  GB38: 55567847915907,
  GB39: 55567844180355,
  GB40: 55567844868483,

  /* GECORRIGEERDE IDS */
  GB2100: 55567816425859,
  GB2150: 55567938421123,
  GB2200: 55567816491395,
  GB2300: 55567816720771,
  GB21: 55567818260867
},
    beige: {
      GB11: 55568164618627, GB12: 55568165110147, GB14: 55568165634435, GB41: 55568170090883,
      GB34: 55568167272835, GB35: 55568167633283, GB36: 56403207324035, GB37: 56403669746051,
      GB39: 56403675808131, GB40: 56403680133507,
      GB2100: 55568146792835, GB2150: 55568147251587, GB2200: 55568147644803, GB21: 55568167895427,
      STRIP1000: 55568171139459
    },
    bronze: {
      GB11: 55568148267395, GB12: 55568149905795, GB14: 55568150659459, GB41: 55568153706883,
      GB34: 55568151118211, GB35: 55568151642499, GB36: 55568177037699, GB37: 56244378730883,
      GB39: 56244379156867, GB40: 56244379681155,
      GB2100: 55568141877635, GB2150: 55568142369155, GB2200: 55568142827907, GB21: 55568152854915,
      STRIP1000: 55568155050371
    },
    champagne: {
      GB11: 55568188572035, GB12: 55568189751683, GB14: 55568191259011, GB41: 55568192766339,
      GB34: 55568192110979, GB35: 55568192405891, GB36: 56404177289603, GB37: 56404351091075,
      GB39: 56404352762243, GB40: 56404355809667,
      GB2100: 55568186376579, GB2150: 55568187261315, GB2200: 55568187687299, GB21: 55568192668035,
      STRIP1000: 55568194470275
    },
    gunmetal: {
      GB11: 55568155672963, GB12: 55568158163331, GB14: 55568160063875, GB41: 55568162619779,
      GB34: 55568160981379, GB35: 55568161276291, GB36: 56403921404291, GB37: 56404915388803,
      GB39: 56404918600067, GB40: 56404919648643,
      GB2100: 55568143319427, GB2150: 55568145777027, GB2200: 55568146235779, GB21: 55568161931651,
      STRIP1000: 55568163996035
    },
    brass: {
      GB11: 55964000420227, GB12: 55964059533699, GB14: 55964064186755, GB41: 55964484108675,
      GB34: 55964293726595, GB35: 55964447539587, GB36: 56404390904195, GB37: 56404617200003,
      GB39: 56404618379651, GB40: 56404624408963,
      GB2100: 55963084226947, GB2150: 55963536785795, GB2200: 55963538227587, GB21: 55964203843971,
      STRIP1000: 55963607892355
    }
  };

  // ---------------------------
  // Labels
  // ---------------------------
  const NAME = {
    GB11: 'GB11 – Eindvoeding',
    GB12: 'GB12 – Eindvoeding',
    GB14: 'GB14 – Middenvoeding',
    GB34: 'GB34 – Hoekstuk',
    GB35: 'GB35 – Hoekstuk',
    GB36: 'GB36 – T-stuk',
    GB37: 'GB37 – T-stuk',
    GB38: 'GB38 – Kruisstuk',
    GB39: 'GB39 – T-stuk',
    GB40: 'GB40 – T-stuk',
    GB41: 'GB41 – Eindkap',
    GB2100: 'GB2100 – 1-fase rail 1 meter',
    GB2150: 'GB2150 – 1-fase rail 1,5 meter',
    GB2200: 'GB2200 – 1-fase rail 2 meter',
    GB2300: 'GB2300 – 1-fase rail 3 meter',
    GB21:  'GB21 – Koppelstuk',
    STRIP1000: 'Afdekstrip 1 meter',
    STRIP1500: 'Afdekstrip 1,5 meter'
  };

  const colorLabel = (key) => ({
    black: 'Zwart', white: 'Wit', grey: 'Grijs',
    beige: 'Beige', bronze: 'Brons', champagne: 'Champagne',
    gunmetal: 'Gunmetal', brass: 'Messing'
  })[key] || key;

  const railLabel = (code) => ({ GB2100: '1m', GB2150: '1,5m', GB2200: '2m', GB2300: '3m' })[code] || code;

  const COLOR_INDICATOR_STYLES = {
    black: { bg: '#1b1b1b', text: '#ffffff', border: '#111111' },
    white: { bg: '#f4f4f4', text: '#111111', border: '#d8d6d0' },
    grey: { bg: '#8f9498', text: '#111111', border: '#767b80' },
    beige: { bg: '#cec5c1', text: '#111111', border: '#b8aea9' },
    bronze: { bg: '#9c8982', text: '#ffffff', border: '#84726c' },
    champagne: { bg: '#d6c6a6', text: '#111111', border: '#b9aa8d' },
    gunmetal: { bg: '#5b5f63', text: '#ffffff', border: '#4a4e52' },
    brass: { bg: '#c8a64b', text: '#111111', border: '#ad8f41' }
  };

  function updateColorIndicatorPill() {
    if (!el.colorName) return;

    if (!state.color) {
      el.colorName.textContent = 'Kies uw railkleur';
      el.colorName.style.background = '';
      el.colorName.style.color = '';
      el.colorName.style.borderColor = '';
      return;
    }

    const style = COLOR_INDICATOR_STYLES[state.color];
    el.colorName.textContent = 'Geselecteerd: ' + colorLabel(state.color);

    if (!style) {
      el.colorName.style.background = '';
      el.colorName.style.color = '';
      el.colorName.style.borderColor = '';
      return;
    }

    el.colorName.style.background = style.bg;
    el.colorName.style.color = style.text;
    el.colorName.style.borderColor = style.border;
  }

  function isPremiumColor(colorKey) {
    return ['beige', 'bronze', 'champagne', 'gunmetal', 'brass'].includes(colorKey);
  }

  function getStripParts() {
    if (!state.addStrips || !state.lastRailParts || !state.color || state.lenWarning) return new Map();
    if (state.color === 'grey') return new Map();

    const stripParts = new Map();
    const add = (code, qty) => {
      if (!qty) return;
      stripParts.set(code, (stripParts.get(code) || 0) + qty);
    };

    if (isPremiumColor(state.color)) {
      const totalMeters =
        (state.lastRailParts.get('GB2100') || 0) * 1 +
        (state.lastRailParts.get('GB2150') || 0) * 1.5 +
        (state.lastRailParts.get('GB2200') || 0) * 2 +
        (state.lastRailParts.get('GB2300') || 0) * 3;
      add('STRIP1000', Math.ceil(totalMeters));
      return stripParts;
    }

    add('STRIP1000', (state.lastRailParts.get('GB2100') || 0) * 1);
    add('STRIP1500', (state.lastRailParts.get('GB2150') || 0) * 1);
    add('STRIP1000', (state.lastRailParts.get('GB2200') || 0) * 2);
    add('STRIP1500', (state.lastRailParts.get('GB2300') || 0) * 2);

    return stripParts;
  }

  function updateStripsUI() {
    if (!el.addStrips) return;
    const unavailable = state.color === 'grey';
    el.addStrips.disabled = unavailable;
    if (unavailable) {
      el.addStrips.checked = false;
      state.addStrips = false;
    } else {
      el.addStrips.checked = !!state.addStrips;
    }

    if (el.addStripsHint) {
      if (unavailable) {
        el.addStripsHint.textContent = 'Afdekstrips zijn niet beschikbaar in grijs.';
      } else if (isPremiumColor(state.color)) {
        el.addStripsHint.textContent = 'Premium afdekstrips zijn alleen per 1 meter beschikbaar en worden automatisch op totale railmeters afgestemd.';
      } else {
        el.addStripsHint.textContent = 'Een afdekstrip sluit de rail netjes af en zorgt voor een strakke uitstraling terwijl vuil en inkijk worden verminderd. Het aantal wordt bepaald op basis van de rail.';
      }
    }
  }

  function buildPartsGroups() {
    const railOrder = (c) => ({ GB2300: 1, GB2200: 2, GB2150: 3, GB2100: 4, GB21: 5 }[c] || 99);
    const groups = [
      {
        title: 'Rails',
        items: Array.from((state.lastRailParts || new Map()).entries())
          .filter(([code, qty]) => qty > 0 && code !== 'GB21')
          .sort((a, b) => railOrder(a[0]) - railOrder(b[0]))
      },
      {
        title: 'Voedingen',
        items: ['GB11', 'GB12', 'GB14']
          .map((code) => [code, state.lastParts ? (state.lastParts.get(code) || 0) : 0])
          .filter(([, qty]) => qty > 0)
      },
      {
        title: 'Hoek-, T- en kruisstukken',
        items: ['GB34', 'GB35', 'GB36', 'GB37', 'GB39', 'GB40', 'GB38']
          .map((code) => [code, state.lastParts ? (state.lastParts.get(code) || 0) : 0])
          .filter(([, qty]) => qty > 0)
      },
      {
        title: 'Koppelstukken',
        items: [['GB21', state.lastRailParts ? (state.lastRailParts.get('GB21') || 0) : 0]]
          .filter(([, qty]) => qty > 0)
      },
      {
        title: 'Afwerking',
        items: [['GB41', state.lastParts ? (state.lastParts.get('GB41') || 0) : 0]]
          .filter(([, qty]) => qty > 0)
      }
    ];

    const stripItems = Array.from(getStripParts().entries()).filter(([, qty]) => qty > 0);
    if (stripItems.length) {
      groups.push({
        title: 'Afdekstrips',
        items: stripItems.sort((a, b) => a[0].localeCompare(b[0]))
      });
    }

    return groups.filter((group) => group.items.length > 0);
  }


  function totalRailMeters() {
    let cm = 0;
    for (const v of state.segmentLenCm.values()) cm += Number(v) || 0;
    return cm > 0 ? (cm / 100) : 0;
  }

  function groupQty(items) {
    return (items || []).reduce((sum, entry) => sum + (Number(entry[1]) || 0), 0);
  }

  function renderPartsPlaceholder(text) {
    el.partsBody.innerHTML = '';
    const empty = document.createElement('div');
    empty.className = 'railcfg__partsEmpty';
    empty.textContent = text || '—';
    el.partsBody.appendChild(empty);
  }

  function renderPartsGroups(groups) {
    el.partsBody.innerHTML = '';

    if (!groups || !groups.length) {
      renderPartsPlaceholder('—');
      return;
    }

    groups.forEach((group) => {
      const section = document.createElement('section');
      section.className = 'railcfg__partsGroup';

      const head = document.createElement('div');
      head.className = 'railcfg__partsGroupHead';

      const title = document.createElement('div');
      title.className = 'railcfg__partsGroupTitle';
      title.textContent = group.title;

      const qty = document.createElement('div');
      qty.className = 'railcfg__partsGroupQty';
      qty.textContent = `${groupQty(group.items)}x`;

      head.appendChild(title);
      head.appendChild(qty);
      section.appendChild(head);

      const list = document.createElement('div');
      list.className = 'railcfg__partsItems';

      group.items.forEach(([code, qtyVal]) => {
        const row = document.createElement('div');
        row.className = 'railcfg__partsItem';

        const name = document.createElement('div');
        name.className = 'railcfg__partsItemName';
        name.textContent = NAME[code] || code;

        const qtyItem = document.createElement('div');
        qtyItem.className = 'railcfg__partsItemQty';
        qtyItem.textContent = `${qtyVal}`;

        row.appendChild(name);
        row.appendChild(qtyItem);
        list.appendChild(row);
      });

      section.appendChild(list);
      el.partsBody.appendChild(section);
    });
  }


  function updateConfidenceUI() {
    const complete = !!(state.lastParts && state.lastRailParts && !state.lenWarning && state.segmentLenCm.size === state.segments.length && state.powerKey && state.color);
    if (el.confidenceBlock) el.confidenceBlock.hidden = !complete;
  }

  function updateCutPlanToggleUI() {
    if (!el.cutPlanToggle || !el.cutPlanWrap) return;
    const hasPlan = !!(state.binPlans && state.binPlans.length && !state.lenWarning && state.segmentLenCm.size > 0);
    el.cutPlanToggle.hidden = !hasPlan;
    el.cutPlanWrap.hidden = !hasPlan || !state.cutPlanOpen;
    el.cutPlanToggle.setAttribute('aria-expanded', hasPlan && state.cutPlanOpen ? 'true' : 'false');
  }

  function updateResultsVisibility() {
    const hasResults = !!(state.lastParts && state.lastRailParts && !state.lenWarning);

    if (el.partsWrap) el.partsWrap.hidden = !hasResults;
    if (el.cutPlanBlock) el.cutPlanBlock.hidden = !hasResults;

    if (!hasResults && el.cutPlanWrap) el.cutPlanWrap.hidden = true;
    if (!hasResults) state.cutPlanOpen = false;
  }

  function updateColorUI() {
    el.colorBtns.forEach((b) => {
      const isActive = !!state.color && b.getAttribute('data-color') === state.color;
      b.classList.toggle('is-active', isActive);
      b.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });

    updateColorIndicatorPill();

    if (el.colorCard) el.colorCard.classList.toggle('is-required', !!state.segments.length && !state.color);
  }

  function getActiveSpotTrack() {
    if (!el.spotTracks || !el.spotTracks.length) return null;
    const wanted = state.color || 'black';
    return el.spotTracks.find((track) => track.getAttribute('data-spots-track') === wanted) || el.spotTracks[0] || null;
  }

  function clampSpotQty(value) {
    const n = Number(value) || 0;
    return Math.max(0, Math.min(99, n));
  }

  function buildSpotSelectionsObject() {
    const out = {};
    for (const [variantId, qtyRaw] of state.spotQtyByVariant.entries()) {
      const key = String(variantId || '').trim();
      const qty = clampSpotQty(qtyRaw);
      if (!key || qty <= 0) continue;
      out[key] = qty;
    }
    return out;
  }

  function buildSpotItemsForPdf() {
    const items = [];
    const seen = new Set();

    root.querySelectorAll('[data-spot-card]').forEach((card) => {
      const variantId = String(card.getAttribute('data-spot-variant-id') || '').trim();
      const qty = clampSpotQty(state.spotQtyByVariant.get(variantId) || 0);
      if (!variantId || qty <= 0 || seen.has(variantId)) return;

      const titleEl = card.querySelector('.railcfg__spotTitle');
      const title = String(titleEl ? titleEl.textContent : '').trim();

      const imgEl = card.querySelector('.railcfg__spotImg');
      const rawImageUrl = String(
        (imgEl && (imgEl.currentSrc || imgEl.getAttribute('src') || imgEl.dataset.src)) || ''
      ).trim();

      let imageUrl = '';
      if (rawImageUrl) {
        try {
          imageUrl = new URL(rawImageUrl, window.location.origin).href;
        } catch (e) {
          imageUrl = rawImageUrl;
        }
      }

      items.push({
        variantId,
        qty,
        title,
        imageUrl
      });
      seen.add(variantId);
    });

    return items;
  }

  function restoreSpotSelections(input) {
    state.spotQtyByVariant = new Map();

    if (!input || typeof input !== 'object') return;

    for (const [variantId, qtyRaw] of Object.entries(input)) {
      const key = String(variantId || '').trim();
      const qty = clampSpotQty(qtyRaw);
      if (!key || qty <= 0) continue;
      state.spotQtyByVariant.set(key, qty);
    }
  }


  function clampAccessoryQty(value) {
    const n = Number(value) || 0;
    return Math.max(0, Math.min(99, n));
  }

  function buildAccessorySelectionsObject() {
    const out = {};
    for (const [variantId, qtyRaw] of state.accessoryQtyByVariant.entries()) {
      const key = String(variantId || '').trim();
      const qty = clampAccessoryQty(qtyRaw);
      if (!key || qty <= 0) continue;
      out[key] = qty;
    }
    return out;
  }

  function saveAccessorySelections() {
    try {
      const data = buildAccessorySelectionsObject();
      if (!Object.keys(data).length) {
        localStorage.removeItem(ACCESSORY_QTY_KEY);
        return;
      }
      localStorage.setItem(ACCESSORY_QTY_KEY, JSON.stringify(data));
    } catch (e) {}
  }

  function restoreAccessorySelections(input) {
    state.accessoryQtyByVariant = new Map();

    if (!input || typeof input !== 'object') return;

    for (const [variantId, qtyRaw] of Object.entries(input)) {
      const key = String(variantId || '').trim();
      const qty = clampAccessoryQty(qtyRaw);
      if (!key || qty <= 0) continue;
      state.accessoryQtyByVariant.set(key, qty);
    }
  }

  function loadAccessorySelections() {
    try {
      const raw = localStorage.getItem(ACCESSORY_QTY_KEY);
      if (!raw) return false;
      const obj = JSON.parse(raw);
      restoreAccessorySelections(obj);
      return true;
    } catch (e) {
      return false;
    }
  }


  function updateSpotQtyUI(card) {
    if (!card) return;
    const variantId = String(card.getAttribute('data-spot-variant-id') || '').trim();
    const qty = clampSpotQty(state.spotQtyByVariant.get(variantId) || 0);
    const qtyEl = card.querySelector('[data-spot-qty]');
    const minus = card.querySelector('[data-spot-minus]');
    if (qtyEl) qtyEl.textContent = String(qty);
    if (minus) minus.disabled = qty <= 0;
    card.classList.toggle('is-selected', qty > 0);
  }

  function updateSpotsUI() {
    if (!el.spotsSection || !el.spotTracks || !el.spotTracks.length) return;

    const activeColor = state.color || 'black';
    let activeTrack = null;

    el.spotTracks.forEach((track) => {
      const isActive = track.getAttribute('data-spots-track') === activeColor;
      track.classList.toggle('is-active', isActive);
      track.hidden = !isActive;
      track.setAttribute('aria-hidden', isActive ? 'false' : 'true');
      track.style.display = isActive ? 'grid' : 'none';
      if (isActive) activeTrack = track;

      track.querySelectorAll('[data-spot-card]').forEach((card) => updateSpotQtyUI(card));
    });

    if (!activeTrack && el.spotTracks[0]) {
      activeTrack = el.spotTracks[0];
      activeTrack.classList.add('is-active');
      activeTrack.hidden = false;
      activeTrack.setAttribute('aria-hidden', 'false');
      activeTrack.style.display = 'grid';
    }

    if (el.spotsColorLabel) {
      el.spotsColorLabel.textContent = state.color ? colorLabel(state.color) : 'Zwart';
    }

    const canScroll = !!(activeTrack && (activeTrack.scrollWidth > activeTrack.clientWidth + 4));
    if (el.spotPrev) el.spotPrev.disabled = !canScroll;
    if (el.spotNext) el.spotNext.disabled = !canScroll;
  }

  function updateAccessoryQtyUI(card) {
    if (!card) return;
    const variantId = String(card.getAttribute('data-accessory-variant-id') || '').trim();
    const qty = clampAccessoryQty(state.accessoryQtyByVariant.get(variantId) || 0);
    const qtyEl = card.querySelector('[data-accessory-qty]');
    const minus = card.querySelector('[data-accessory-minus]');
    const addBtn = card.querySelector('[data-accessory-add]');
    if (qtyEl) qtyEl.textContent = String(qty);
    if (minus) minus.disabled = qty <= 0;
    if (addBtn) addBtn.disabled = qty <= 0;
    card.classList.toggle('is-selected', qty > 0);
  }

  function setAccessoryQty(variantId, nextQty) {
    const key = String(variantId || '').trim();
    if (!key) return;
    const qty = clampAccessoryQty(nextQty);
    if (qty <= 0) state.accessoryQtyByVariant.delete(key);
    else state.accessoryQtyByVariant.set(key, qty);

    saveAccessorySelections();

    const selector = '[data-accessory-card][data-accessory-variant-id="' + CSS.escape(key) + '"]';
    const card = root.querySelector(selector);
    if (card) updateAccessoryQtyUI(card);
  }

  function updateAccessoriesUI() {
    if (!el.accessoryTracks || !el.accessoryTracks.length) return;

    const activeColor = state.color || 'black';
    let activeTrack = null;

    el.accessoryTracks.forEach((track) => {
      const isActive = track.getAttribute('data-accessories-track') === activeColor;
      track.classList.toggle('is-active', isActive);
      track.hidden = !isActive;
      track.setAttribute('aria-hidden', isActive ? 'false' : 'true');
      track.style.display = isActive ? 'grid' : 'none';
      if (isActive) activeTrack = track;

      track.querySelectorAll('[data-accessory-card]').forEach((card) => updateAccessoryQtyUI(card));
    });

    if (!activeTrack && el.accessoryTracks[0]) {
      activeTrack = el.accessoryTracks[0];
      activeTrack.classList.add('is-active');
      activeTrack.hidden = false;
      activeTrack.setAttribute('aria-hidden', 'false');
      activeTrack.style.display = 'grid';
    }

    if (el.accessoriesColorLabel) {
      el.accessoriesColorLabel.textContent = state.color ? colorLabel(state.color) : 'Zwart';
    }
  }

  function setSpotQty(variantId, nextQty) {
    const key = String(variantId || '').trim();
    if (!key) return;
    const qty = clampSpotQty(nextQty);
    if (qty <= 0) state.spotQtyByVariant.delete(key);
    else state.spotQtyByVariant.set(key, qty);

    setDesignCode(null);

    const selector = '[data-spot-card][data-spot-variant-id="' + CSS.escape(key) + '"]';
    const card = root.querySelector(selector);
    if (card) updateSpotQtyUI(card);
  }


  function getSpotCartItems() {
    const items = [];

    el.spotTracks.forEach((track) => {
      const isCurrentColor = track.getAttribute('data-spots-track') === (state.color || 'black');
      if (!isCurrentColor) return;

      track.querySelectorAll('[data-spot-card]').forEach((card) => {
        const variantId = Number(card.getAttribute('data-spot-variant-id') || 0);
        const qty = clampSpotQty(state.spotQtyByVariant.get(String(variantId)) || 0);
        if (variantId && qty > 0) items.push({ id: variantId, quantity: qty });
      });
    });

    return items;
  }

  function bindSpotCarousel() {
    if (!el.spotTracks || !el.spotTracks.length) return;

    el.spotTracks.forEach((track) => {
      track.querySelectorAll('[data-spot-card]').forEach((card) => {
        const variantId = String(card.getAttribute('data-spot-variant-id') || '').trim();

        const plus = card.querySelector('[data-spot-plus]');
        const minus = card.querySelector('[data-spot-minus]');

        if (plus) {
          plus.addEventListener('click', () => {
            const cur = clampSpotQty(state.spotQtyByVariant.get(variantId) || 0);
            setSpotQty(variantId, cur + 1);
          });
        }

        if (minus) {
          minus.addEventListener('click', () => {
            const cur = clampSpotQty(state.spotQtyByVariant.get(variantId) || 0);
            setSpotQty(variantId, cur - 1);
          });
        }

        updateSpotQtyUI(card);
      });
    });

    const scrollTrackBy = (dir) => {
      const track = getActiveSpotTrack();
      if (!track) return;
      const amount = Math.max(260, Math.round(track.clientWidth * 0.82)) * dir;
      track.scrollBy({ left: amount, behavior: 'smooth' });
    };

    if (el.spotPrev) el.spotPrev.addEventListener('click', () => scrollTrackBy(-1));
    if (el.spotNext) el.spotNext.addEventListener('click', () => scrollTrackBy(1));

    el.spotTracks.forEach((track) => {
      track.addEventListener('scroll', () => {
        if (track.classList.contains('is-active')) updateSpotsUI();
      }, { passive: true });
    });

    updateSpotsUI();
  }

  async function handleAccessoryAdd(card) {
    if (!card) return;

    const variantId = Number(card.getAttribute('data-accessory-variant-id') || 0);
    const key = String(variantId || '').trim();
    const qty = clampAccessoryQty(state.accessoryQtyByVariant.get(key) || 0);
    const addBtn = card.querySelector('[data-accessory-add]');
    const defaultLabel = addBtn ? (addBtn.dataset.defaultLabel || addBtn.textContent || 'Toevoegen') : 'Toevoegen';

    if (!variantId || qty <= 0 || !addBtn) return;

    addBtn.disabled = true;
    addBtn.textContent = 'Toevoegen…';

    try {
      await addToCart([{ id: variantId, quantity: qty }]);
      state.accessoryQtyByVariant.delete(key);
      saveAccessorySelections();
      updateAccessoryQtyUI(card);
      addBtn.textContent = 'Toegevoegd ✓';
      card.classList.add('is-added');

      window.setTimeout(() => {
        card.classList.remove('is-added');
        addBtn.textContent = defaultLabel;
        updateAccessoryQtyUI(card);
      }, 1600);
    } catch (err) {
      addBtn.textContent = 'Probeer opnieuw';
      window.setTimeout(() => {
        addBtn.textContent = defaultLabel;
        updateAccessoryQtyUI(card);
      }, 1800);
      console.error(err);
    }
  }

  function bindAccessoryCarousel() {
    if (!el.accessoryTracks || !el.accessoryTracks.length) return;

    el.accessoryTracks.forEach((track) => {
      track.querySelectorAll('[data-accessory-card]').forEach((card) => {
        const variantId = String(card.getAttribute('data-accessory-variant-id') || '').trim();
        const plus = card.querySelector('[data-accessory-plus]');
        const minus = card.querySelector('[data-accessory-minus]');
        const addBtn = card.querySelector('[data-accessory-add]');

        if (addBtn && !addBtn.dataset.defaultLabel) {
          addBtn.dataset.defaultLabel = (addBtn.textContent || '').trim() || 'Toevoegen';
        }

        if (plus) {
          plus.addEventListener('click', () => {
            const cur = clampAccessoryQty(state.accessoryQtyByVariant.get(variantId) || 0);
            setAccessoryQty(variantId, cur + 1);
          });
        }

        if (minus) {
          minus.addEventListener('click', () => {
            const cur = clampAccessoryQty(state.accessoryQtyByVariant.get(variantId) || 0);
            setAccessoryQty(variantId, cur - 1);
          });
        }

        if (addBtn) {
          addBtn.addEventListener('click', () => {
            handleAccessoryAdd(card);
          });
        }

        updateAccessoryQtyUI(card);
      });
    });

    updateAccessoriesUI();
  }

  function setOfferPanelOpen(open) {
    if (!el.offerPanel || !el.btnOffer) return;
    const isOpen = !!open;
    el.offerPanel.hidden = !isOpen;
    el.offerPanel.classList.toggle('is-open', isOpen);
    el.btnOffer.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
  }

  function setOfferFormMsg(text, kind) {
    if (!el.offerFormMsg) return;
    const msg = String(text || '').trim();
    el.offerFormMsg.textContent = msg;
    el.offerFormMsg.hidden = !msg;
    el.offerFormMsg.classList.remove('is-ok', 'is-err');
    if (!msg) return;
    el.offerFormMsg.classList.add(kind === 'err' ? 'is-err' : 'is-ok');
  }

  async function ensureOfferDesignCode() {
    if (!state.segments.length) throw new Error('Teken eerst een ontwerp voordat u een bericht verstuurt.');
    if (!state.designCode) {
      setOfferFormMsg('Ontwerpcode wordt aangemaakt…', 'ok');
      const saved = await saveDesignOnServer();
      setDesignCode(saved.code);
    }
    syncOfferFormDesignData();
    setOfferFormMsg('', 'ok');
    return state.designCode || '';
  }

  function syncOfferFormDesignData() {
    const code = state.designCode || '';
    const shortUrl = getShortDesignUrl(code);

    if (el.offerDesignCode) {
      el.offerDesignCode.value = shortUrl || '';
    }
  }

  function setMsg(text, kind) {
    if (!el.cartMsg) return;
    el.cartMsg.textContent = text || '';
    el.cartMsg.classList.remove('is-ok', 'is-err');
    if (kind) el.cartMsg.classList.add(kind === 'ok' ? 'is-ok' : 'is-err');
  }

  function isCriticalConfigAlertMessage(text) {
    const msg = String(text || '').trim();
    if (!msg) return false;

    if (msg === getInvalidStraightSplitMessage()) return true;

    return (
      msg.startsWith('Er is iets misgegaan bij het berekenen van uw configuratie') ||
      msg.startsWith('De configurator is nog niet volledig ingesteld') ||
      msg.startsWith('Geen passende onderdelen gevonden') ||
      msg.startsWith('Worker URL ontbreekt') ||
      msg.startsWith('Export mislukt')
    );
  }

  function setConfigAlert(text) {
    if (!el.configAlert) return;
    const msg = String(text || '').trim();
    if (!msg || !isCriticalConfigAlertMessage(msg)) {
      el.configAlert.hidden = true;
      el.configAlert.textContent = '';
      return;
    }
    el.configAlert.textContent = msg;
    el.configAlert.hidden = false;
  }

  function clearConfigAlert() {
    if (!el.configAlert) return;
    el.configAlert.hidden = true;
    el.configAlert.textContent = '';
  }


  function syncRailValidationAlert() {
    const railMsg = getRailValidationMessage();
    if (railMsg) {
      setConfigAlert(railMsg);
      return;
    }

    if (!el.configAlert) return;
    const current = String(el.configAlert.textContent || '').trim();
    if (current === getInvalidStraightSplitMessage()) {
      clearConfigAlert();
    }
  }

  let designMsgTimer = null;

  function setDesignMsg(text, kind) {
    if (!el.designMsg) return;

    if (designMsgTimer) {
      clearTimeout(designMsgTimer);
      designMsgTimer = null;
    }

    el.designMsg.textContent = text || '';
    el.designMsg.classList.remove('is-ok', 'is-err', 'is-visible');

    if (!text) return;

    if (kind) el.designMsg.classList.add(kind === 'ok' ? 'is-ok' : 'is-err');

    void el.designMsg.offsetWidth;
    el.designMsg.classList.add('is-visible');

    designMsgTimer = window.setTimeout(() => {
      if (!el.designMsg) return;
      el.designMsg.classList.remove('is-visible');
    }, 3000);
  }


  function setDesignCode(code) {
    state.designCode = code ? normalizeDesignCode(code) : null;
    if (el.designCodeInput) el.designCodeInput.value = state.designCode || '';
    syncOfferFormDesignData();
  }

  function normalizeDesignCode(code) {
    return String(code || '').trim().toUpperCase().replace(/[^A-Z0-9-]/g, '');
  }

  function focusDesignCode(selectAll) {
    if (!el.designCodeInput) return;
    try {
      el.designCodeInput.focus({ preventScroll: true });
    } catch (e) {
      el.designCodeInput.focus();
    }
    if (selectAll) {
      try { el.designCodeInput.select(); } catch (e) {}
    }
  }

  function getShortDesignUrl(code) {
    if (!WORKER_BASE || !code) return '';
    return WORKER_BASE + '/r/' + encodeURIComponent(code);
  }

  async function saveDesignOnServer() {
  if (!WORKER_BASE) throw new Error('Worker URL ontbreekt (section setting).');
  if (!state.segments.length) throw new Error('Teken eerst een ontwerp.');

  const segLenObj = {};
  for (const [k, v] of state.segmentLenCm.entries()) segLenObj[k] = v;

  const centerLenObj = {};
  for (const [k, v] of state.centerLenCm.entries()) centerLenObj[k] = v;

  const payload = {
    color: state.color,
    powerKey: state.powerKey,
    segments: state.segments,
    measureMode: state.measureMode,
    segmentLenCm: segLenObj,
    centerLenCm: centerLenObj,
    addStrips: !!state.addStrips,
    spotSelections: buildSpotSelectionsObject()
  };

  const res = await fetch(WORKER_BASE + '/save', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload)
  });

  const out = await res.json().catch(() => ({}));
  if (!res.ok || out?.ok === false || !out?.code) {
    throw new Error(out?.reason || `Opslaan mislukt (${res.status})`);
  }

  setDesignCode(out.code);
  saveAutosave();
  return out;
}

async function loadDesignByCode(code) {
  if (!WORKER_BASE) throw new Error('Worker URL ontbreekt (section setting).');

  const res = await fetch(WORKER_BASE + '/load/' + encodeURIComponent(code), {
    method: 'GET',
    headers: { 'Accept': 'application/json' }
  });

  const out = await res.json().catch(() => ({}));
  if (!res.ok || out?.ok === false || !out?.config) {
    throw new Error(out?.reason || 'Ontwerp niet gevonden.');
  }

  const ok = applyCfgObject(out.config);
  if (!ok) throw new Error('Opgeslagen ontwerp is ongeldig.');

  setDesignCode(out.code || code);
  saveAutosave();
  return true;
}


  async function handleSaveDesignOnly() {
    if (!state.segments.length) {
      setDesignMsg('Teken eerst een ontwerp om te kunnen bewaren.', 'err');
      return;
    }

    try {
      if (el.btnSaveDesign) {
        el.btnSaveDesign.disabled = true;
        el.btnSaveDesign.textContent = 'Bewaren…';
      }

      if (state.designCode) {
        saveAutosave();
        await trackRailcfgEvent('save_design_click', { designCode: state.designCode }, { waitForResponse: true });
        focusDesignCode(true);
        setDesignMsg(`Ontwerp ${state.designCode} is al opgeslagen.`, 'ok');
        return;
      }

      setDesignMsg('Ontwerp wordt opgeslagen…', 'ok');
      const out = await saveDesignOnServer();
      await trackRailcfgEvent('save_design_click', { designCode: state.designCode || out.code }, { waitForResponse: true });
      focusDesignCode(true);
      setDesignMsg(`Ontwerp ${out.code} is opgeslagen.`, 'ok');
    } catch (err) {
      setDesignMsg(err?.message || 'Ontwerp opslaan mislukt.', 'err');
    } finally {
      if (el.btnSaveDesign) {
        el.btnSaveDesign.disabled = false;
        el.btnSaveDesign.textContent = el.btnSaveDesign.dataset.defaultLabel || 'Bewaar ontwerp';
      }
    }
  }


  async function handleManualLoadDesign() {
    try {
      const code = normalizeDesignCode(el.designCodeInput ? el.designCodeInput.value : '');
      if (!code) {
        setDesignMsg('Vul eerst een ontwerpcode in.', 'err');
        if (el.designCodeInput) el.designCodeInput.focus();
        return;
      }

  if (el.btnLoadDesign) {
        el.btnLoadDesign.disabled = true;
        el.btnLoadDesign.textContent = 'Laden…';
      }

      setDesignMsg('Ontwerp wordt geladen…', 'ok');
      await loadDesignByCode(code);
      render();
      focusDesignCode(false);
      setDesignMsg(`Ontwerp ${code} geladen.`, 'ok');
    } catch (err) {
      setDesignMsg(err?.message || 'Ontwerp laden mislukt.', 'err');
    } finally {

  if (el.btnLoadDesign) {
        el.btnLoadDesign.disabled = false;
        el.btnLoadDesign.textContent = 'Ontwerp laden';
      }
    }
  }

  async function setCartAttributes(attrs) {
    const res = await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ attributes: attrs || {} })
    });
    if (!res.ok) {
      let txt = '';
      try { txt = await res.text(); } catch (e) {}
      throw new Error('Cart update failed: ' + (txt || res.status));
    }
    return await res.json();
  }

  // ---------------------------
  // Drawing + geometry helpers
  // ---------------------------
  const SNAP_CM = 10;
  const UNIT_PER_10CM = 50;
  const unitPerCm = () => UNIT_PER_10CM / 10;

  function snap(v) {
    const step = SNAP_CM * unitPerCm();
    return Math.round(v / step) * step;
  }
  const samePoint = (p, q) => p.x === q.x && p.y === q.y;
  const pointKey = (p) => `${p.x},${p.y}`;

  function normSegKey(seg) {
    const a = { x: seg.a.x, y: seg.a.y };
    const b = { x: seg.b.x, y: seg.b.y };
    if (a.x === b.x) {
      if (a.y > b.y) { const t = a.y; a.y = b.y; b.y = t; }
    } else {
      if (a.x > b.x) { const t = a.x; a.x = b.x; b.x = t; }
    }
    return `${a.x},${a.y}|${b.x},${b.y}`;
  }

  function segmentMidpoint(seg) {
    return { x: (seg.a.x + seg.b.x) / 2, y: (seg.a.y + seg.b.y) / 2 };
  }
  function segmentLabelOffset(seg) {
    const dx = seg.b.x - seg.a.x;
    const dy = seg.b.y - seg.a.y;
    return (Math.abs(dx) >= Math.abs(dy)) ? { ox: 0, oy: -18 } : { ox: 18, oy: 0 };
  }

  function normSeg(seg) {
    const a = { x: seg.a.x, y: seg.a.y };
    const b = { x: seg.b.x, y: seg.b.y };
    if (a.y === b.y) {
      if (a.x > b.x) { const t = a.x; a.x = b.x; b.x = t; }
      return { a, b, ori: 'H' };
    }
    if (a.y > b.y) { const t = a.y; a.y = b.y; b.y = t; }
    return { a, b, ori: 'V' };
  }
  function onSegment(p, seg) {
    const s = normSeg(seg);
    if (s.ori === 'H') return p.y === s.a.y && p.x >= s.a.x && p.x <= s.b.x;
    return p.x === s.a.x && p.y >= s.a.y && p.y <= s.b.y;
  }
  function distPointToSeg(p, seg) {
    const a = seg.a, b = seg.b;
    if (a.x === b.x) {
      const x = a.x;
      const y1 = Math.min(a.y, b.y), y2 = Math.max(a.y, b.y);
      const yy = Math.max(y1, Math.min(p.y, y2));
      return Math.hypot(p.x - x, p.y - yy);
    } else {
      const y = a.y;
      const x1 = Math.min(a.x, b.x), x2 = Math.max(a.x, b.x);
      const xx = Math.max(x1, Math.min(p.x, x2));
      return Math.hypot(p.y - y, p.x - xx);
    }
  }
  function closestPointOnSegSnapped(p, seg) {
    const a = seg.a, b = seg.b;
    let q;
    if (a.x === b.x) {
      const x = a.x;
      const y1 = Math.min(a.y, b.y), y2 = Math.max(a.y, b.y);
      const y = Math.max(y1, Math.min(p.y, y2));
      q = { x, y };
    } else {
      const y = a.y;
      const x1 = Math.min(a.x, b.x), x2 = Math.max(a.x, b.x);
      const x = Math.max(x1, Math.min(p.x, x2));
      q = { x, y };
    }
    return { x: snap(q.x), y: snap(q.y) };
  }

  function svgPointFromEvent(evt) {
    const pt = el.svg.createSVGPoint();
    const e = evt.touches ? evt.touches[0] : evt;
    pt.x = e.clientX; pt.y = e.clientY;
    const ctm = el.svg.getScreenCTM();
    if (!ctm) return { x: 0, y: 0 };
    const p = pt.matrixTransform(ctm.inverse());
    return { x: p.x, y: p.y };
  }

  function normalizeSegment(a, b) {
    const dx = Math.abs(b.x - a.x);
    const dy = Math.abs(b.y - a.y);
    return (dx >= dy) ? { a, b: { x: b.x, y: a.y } } : { a, b: { x: a.x, y: b.y } };
  }

  function isEditable() {
    return !state.isLocked;
  }

  function updateLockUI() {
    const locked = !!state.isLocked;

    if (el.svg) {
      el.svg.style.cursor = locked ? 'not-allowed' : 'crosshair';
    }

    setDisabledAll(el.btnUndo, locked);
    setDisabledAll(el.btnClear, locked);
    setDisabledAll(el.btnPickPower, !state.segments.length);
    setDisabledAll(el.btnClearPower, !state.powerKey);
  }

  function scrollToSection(target) {
    if (!target) return;

    const rect = target.getBoundingClientRect();
    const absoluteTop = rect.top + window.scrollY;
    const top = Math.max(0, absoluteTop - 24);

    window.scrollTo({ top, behavior: 'smooth' });
  }

  function scrollToDrawStep() {
    scrollToSection(el.step2Section);
  }

  function scrollToPowerStep() {
    scrollToSection(el.step3Section);
  }

  function scrollToLengthsStep() {
    scrollToSection(el.step4Section);
  }

  function scrollToSpotsStep() {
    scrollToSection(el.step5Section);
  }

  function finishDrawingAndAdvance() {
    if (!state.segments.length) return;
    if (hasRailValidationError()) {
      setConfigAlert(getRailValidationMessage());
      updateCanvasStatus();
      return;
    }

    drawing.active = false;
    drawing.start = null;
    stopPreview();
    state.pickPowerMode = false;

    const lengthsComplete = state.segmentLenCm.size === state.segments.length;

    render();

    window.setTimeout(() => {
      if (!state.powerKey) {
        scrollToPowerStep();
        return;
      }

      if (!lengthsComplete) {
        scrollToLengthsStep();
        return;
      }

      scrollToSpotsStep();
    }, 60);
  }

  // ---------------------------
  // State
  // ---------------------------
  const state = {
    points: [],
    segments: [],
    powerKey: null,
    pickPowerMode: false,
    color: null,
    designCode: null,
    measureMode: null,
    segmentLenCm: new Map(), // Map<segKey, rail-cm>
    centerLenCm: new Map(),  // Map<segKey, hart-cm>
    isLocked: false,
    spotQtyByVariant: new Map(),
    accessoryQtyByVariant: new Map(),
    addStrips: false,
    cutPlanOpen: false,

    // Worker cache
    lastWorkerOut: null,
    lastParts: null,       // Map
    lastRailParts: null,   // Map incl GB21
    binPlans: null,        // Array

    lenWarning: false,
    lenWarningText: '',
    invalidStraightSplit: false,
    invalidStraightSplitMessage: ''
  };

  const AUTOSAVE_KEY = 'railcfg_autosave_v1';
  const ACCESSORY_QTY_KEY = 'railcfg_accessory_qty_v1';

  function buildAutosaveObject() {
    const segLenObj = {};
    for (const [k, v] of state.segmentLenCm.entries()) segLenObj[k] = v;

    const centerLenObj = {};
    for (const [k, v] of state.centerLenCm.entries()) centerLenObj[k] = v;

    return {
      color: state.color,
      powerKey: state.powerKey,
      segments: state.segments,
      measureMode: state.measureMode,
      segmentLenCm: segLenObj,
      centerLenCm: centerLenObj,
      designCode: state.designCode || null,
      addStrips: !!state.addStrips,
      spotSelections: buildSpotSelectionsObject()
    };
  }

  function saveAutosave() {
    try {
      if (!state.segments.length) {
        localStorage.removeItem(AUTOSAVE_KEY);
        return;
      }
      localStorage.setItem(AUTOSAVE_KEY, JSON.stringify(buildAutosaveObject()));
    } catch (e) {}
  }

  function loadAutosave() {
    try {
      const raw = localStorage.getItem(AUTOSAVE_KEY);
      if (!raw) return false;
      const obj = JSON.parse(raw);
      const ok = applyCfgObject(obj);
      if (ok && obj.designCode) setDesignCode(obj.designCode);
      return !!ok;
    } catch (e) {
      return false;
    }
  }

  function clearAutosave() {
    try {
      localStorage.removeItem(AUTOSAVE_KEY);
    } catch (e) {}
  }

  // ---------------------------
  // Shareable link (?cfg=...)
  // ---------------------------
  let shareTimer = null;
  let lastCfgStr = null;

  function toBase64Url(u8) {
    let bin = '';
    for (let i = 0; i < u8.length; i++) bin += String.fromCharCode(u8[i]);
    return btoa(bin).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/g, '');
  }
  function fromBase64Url(s) {
    const b64 = s.replace(/-/g, '+').replace(/_/g, '/');
    const pad = '='.repeat((4 - (b64.length % 4)) % 4);
    const bin = atob(b64 + pad);
    const u8 = new Uint8Array(bin.length);
    for (let i = 0; i < bin.length; i++) u8[i] = bin.charCodeAt(i);
    return u8;
  }

  function buildCfgObject() {
    const segLenObj = {};
    for (const [k, v] of state.segmentLenCm.entries()) segLenObj[k] = v;

    const centerLenObj = {};
    for (const [k, v] of state.centerLenCm.entries()) centerLenObj[k] = v;

    return {
      v: 1,
      color: state.color,
      powerKey: state.powerKey,
      segments: state.segments,
      measureMode: state.measureMode,
      segmentLenCm: segLenObj,
      centerLenCm: centerLenObj,
      addStrips: !!state.addStrips,
      spotSelections: buildSpotSelectionsObject()
    };
  }

  function encodeCfg(obj) {
    const json = JSON.stringify(obj);
    const u8 = new TextEncoder().encode(json);
    return toBase64Url(u8);
  }

  function decodeCfg(cfgStr) {
    const u8 = fromBase64Url(cfgStr);
    const json = new TextDecoder().decode(u8);
    return JSON.parse(json);
  }

  function setUrlCfg(cfgStr) {
    const url = new URL(window.location.href);
    if (!cfgStr) url.searchParams.delete('cfg');
    else url.searchParams.set('cfg', cfgStr);
    history.replaceState(null, '', url.toString());
  }

function scheduleShareUpdate() {
  // cfg-links niet meer genereren
}

  function applyCfgObject(obj) {
    if (!obj || !Array.isArray(obj.segments)) return false;

    const color = obj.color == null ? null : String(obj.color || '').trim();
    state.color = (color && (color in VARIANTS)) ? color : null;

    state.segments = obj.segments.map(s => ({
      a: { x: Number(s.a.x), y: Number(s.a.y) },
      b: { x: Number(s.b.x), y: Number(s.b.y) }
    })).filter(s => isFinite(s.a.x) && isFinite(s.a.y) && isFinite(s.b.x) && isFinite(s.b.y));

    state.powerKey = obj.powerKey ? String(obj.powerKey) : null;
    state.measureMode = obj.measureMode === 'hart' ? 'hart' : (obj.measureMode === 'rail' ? 'rail' : null);
    state.isLocked = false;
    state.addStrips = !!obj.addStrips;
    if (el.addStrips) el.addStrips.checked = !!state.addStrips;
    restoreSpotSelections(obj.spotSelections || obj.spotQtyByVariant);

    state.segmentLenCm = new Map();
    state.centerLenCm = new Map();
    const segLen = obj.segmentLenCm && typeof obj.segmentLenCm === 'object' ? obj.segmentLenCm : {};
    const centerLen = obj.centerLenCm && typeof obj.centerLenCm === 'object' ? obj.centerLenCm : {};
    for (const [k, v] of Object.entries(segLen)) {
      const n = parseCmInput(v);
      if (n != null) state.segmentLenCm.set(k, n);
    }
    for (const [k, v] of Object.entries(centerLen)) {
      const n = parseCmInput(v);
      if (n != null) state.centerLenCm.set(k, n);
    }

    rebuildPoints();
    recomputeDerivedLengthsFromMode();
    resetWorkerState();
    return true;
  }


  async function tryLoadDesignFromUrl() {
    const url = new URL(window.location.href);
    const code = (url.searchParams.get('design') || '').trim().toUpperCase();
    if (!code) return false;
    await loadDesignByCode(code);
    return true;
  }

  function tryLoadCfgFromUrl() {
    const url = new URL(window.location.href);
    const cfgStr = url.searchParams.get('cfg');
    if (!cfgStr) return false;

    try {
      const obj = decodeCfg(cfgStr);
      const ok = applyCfgObject(obj);
      if (ok) lastCfgStr = cfgStr;
      return ok;
    } catch (e) {
      setUrlCfg(null);
      return false;
    }
  }

  async function emailDesignLink() {
    let code = state.designCode;
    let shortUrl = '';

    if (code) {
      shortUrl = getShortDesignUrl(code);
    } else {
      const out = await saveDesignOnServer();
      code = out.code;
      shortUrl = out.shortUrl || getShortDesignUrl(code);
    }

    await trackRailcfgEvent('email_link_click', { designCode: code || state.designCode || null }, { waitForResponse: true });

    const link = shortUrl || window.location.href;
    const subject = `Mijn Railspot.nl railontwerp ${code || ''}`.trim();
    const body = [
      'Beste,',
      '',
      'Hierbij mijn railontwerp:',
      link,
      '',
      code ? `Ontwerpcode: ${code}` : '',
      '',
      'Met vriendelijke groet'
    ].filter((line, index, arr) => line || arr[index - 1] !== '').join('\n');

    focusDesignCode(true);
    window.location.href = `mailto:?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
    setDesignMsg(`E-mailprogramma geopend voor ontwerp ${code || '—'}.`, 'ok');
  }

  // ---------------------------
  // Segment length helpers
  // ---------------------------
  function pruneSegmentLenMap() {
    const existing = new Set(state.segments.map(normSegKey));
    for (const k of Array.from(state.segmentLenCm.keys())) {
      if (!existing.has(k)) state.segmentLenCm.delete(k);
    }
    for (const k of Array.from(state.centerLenCm.keys())) {
      if (!existing.has(k)) state.centerLenCm.delete(k);
    }
  }
  function allSegmentLengthsFilled() {
    const map = getDisplayLengthMap();
    return !!(state.measureMode && state.segments.length > 0 && map && map.size === state.segments.length);
  }

  // ---------------------------
  // Worker (debounced + stale protection)
  // ---------------------------
  let workerTimer = null;
  let workerSeq = 0;

  async function computeViaWorker() {
    if (!WORKER_BASE) throw new Error('Worker URL ontbreekt (section setting).');

    const segLenObj = {};
    for (const [k, v] of state.segmentLenCm.entries()) segLenObj[k] = v;

    const payload = {
      color: state.color,
      powerKey: state.powerKey,
      segments: state.segments,
      segmentLenCm: segLenObj
    };

    const res = await fetch(WORKER_BASE + '/solve', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    });

    const out = await res.json().catch(() => ({}));
    if (!res.ok) throw new Error(out?.reason || `Worker error (${res.status})`);
    if (out && out.ok === false) throw new Error(out?.reason || 'Geen resultaat (Worker).');
    return out;
  }

  function scheduleComputeParts() {
    if (!WORKER_BASE) return;
    if (workerTimer) clearTimeout(workerTimer);
    workerTimer = setTimeout(computeParts, 180);
  }

  function resetWorkerState() {
    if (root) root.classList.remove('railcfg--results-ready');
    state.lastWorkerOut = null;
    state.lastParts = null;
    state.lastRailParts = null;
    state.binPlans = null;
    state.lenWarning = false;
    state.lenWarningText = '';
  }

  // ---------------------------
  // Rails UI helpers (optional block)
  // ---------------------------
  function setRailsBlock(open) {
    if (!el.railsBlock || !el.railsToggle) return;
    el.railsBlock.hidden = !open;
    el.railsToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  function updateRailsToggleState() {
    if (el.railsToggle) {
      el.railsToggle.disabled = !(state.segments && state.segments.length);
    }

    if (el.railsMiniStatus) {
      if (!state.segments.length) el.railsMiniStatus.textContent = 'verplicht';
      else if (countEnteredLengths() > 0) el.railsMiniStatus.textContent = `${countEnteredLengths()}/${state.segments.length} ingevuld`;
      else el.railsMiniStatus.textContent = 'verplicht';
    }

    if (el.railsBlock) {
      el.railsBlock.hidden = false;
    }
  }

  if (el.railsToggle) {
    el.railsToggle.addEventListener('click', () => {
      const isOpen = el.railsBlock && !el.railsBlock.hidden;
      setRailsBlock(!isOpen);
    });
  }
  if (el.railsClose) {
    el.railsClose.addEventListener('click', () => setRailsBlock(false));
  }

  // ---------------------------
  // Cut plan
  // ---------------------------
  function renderCutPlan() {
    const target = el.cutPlan || el.summary;
    if (!target) return;

    if (el.cutPlan) el.cutPlan.innerHTML = '';

    if (!state.binPlans || state.lenWarning || state.segmentLenCm.size === 0) {
      if (el.cutPlan) el.cutPlan.innerHTML = '';
      updateResultsVisibility();
      updateConfidenceUI();
      updateCutPlanToggleUI();
      return;
    }

    const groups = new Map();
    for (const b of state.binPlans) {
      if (!groups.has(b.code)) groups.set(b.code, []);
      groups.get(b.code).push(b);
    }

    const order = (c) => ({ GB2300: 1, GB2200: 2, GB2150: 3, GB2100: 4 }[c] || 99);
    const codes = Array.from(groups.keys()).sort((a, b) => order(a) - order(b));

    const wrap = document.createElement('div');
    wrap.className = 'railcfg__cutplanInner';

    for (const code of codes) {
      const bins = groups.get(code) || [];
      const rail = document.createElement('section');
      rail.className = 'railcfg__cutplanRail';

      const head = document.createElement('div');
      head.className = 'railcfg__cutplanRailHead';
      head.textContent = `${railLabel(code)} rail (${code}) – ${bins.length}x`;
      rail.appendChild(head);

      const items = document.createElement('div');
      items.className = 'railcfg__cutplanRailItems';

      bins.forEach((b, i) => {
        const line = document.createElement('div');
        line.className = 'railcfg__cutplanRailItem';
        line.textContent = `Rail ${i + 1}: ${b.cutsStr}`;
        items.appendChild(line);
      });

      rail.appendChild(items);
      wrap.appendChild(rail);
    }

    (el.cutPlan || target).appendChild(wrap);
  }

  function getInvalidStraightSplitMessage() {
    return 'Er is iets verkeerd met het tekenen in uw tekening. Begin opnieuw met tekenen.';
  }

  function getRailValidationMessage() {
    if (state.invalidStraightSplit) {
      return state.invalidStraightSplitMessage || getInvalidStraightSplitMessage();
    }
    return '';
  }

  function hasRailValidationError() {
    return !!getRailValidationMessage();
  }

  function hasStrictCollinearOverlap(segA, segB) {
    if (!segA || !segB) return false;

    const bothHorizontal = segA.a.y === segA.b.y && segB.a.y === segB.b.y;
    if (bothHorizontal) {
      if (segA.a.y !== segB.a.y) return false;
      const a1 = Math.min(segA.a.x, segA.b.x);
      const a2 = Math.max(segA.a.x, segA.b.x);
      const b1 = Math.min(segB.a.x, segB.b.x);
      const b2 = Math.max(segB.a.x, segB.b.x);
      return Math.max(a1, b1) < Math.min(a2, b2);
    }

    const bothVertical = segA.a.x === segA.b.x && segB.a.x === segB.b.x;
    if (bothVertical) {
      if (segA.a.x !== segB.a.x) return false;
      const a1 = Math.min(segA.a.y, segA.b.y);
      const a2 = Math.max(segA.a.y, segA.b.y);
      const b1 = Math.min(segB.a.y, segB.b.y);
      const b2 = Math.max(segB.a.y, segB.b.y);
      return Math.max(a1, b1) < Math.min(a2, b2);
    }

    return false;
  }

  function detectInvalidStraightSplit() {
    if (!state.segments.length) return false;

    const nodes = buildNodeMapFromSegments(state.segments);
    for (const [key] of nodes.entries()) {
      if (state.powerKey && key === state.powerKey) continue;
      if (isCollinearDegree2Node(key, nodes)) return true;
    }

    for (let i = 0; i < state.segments.length; i++) {
      for (let j = i + 1; j < state.segments.length; j++) {
        if (hasStrictCollinearOverlap(state.segments[i], state.segments[j])) return true;
      }
    }

    return false;
  }

  function updateInvalidDrawingState() {
    const invalid = detectInvalidStraightSplit();
    state.invalidStraightSplit = invalid;
    state.invalidStraightSplitMessage = invalid ? getInvalidStraightSplitMessage() : '';
  }

  // ---------------------------
  // Compute parts (Worker-only)
  // ---------------------------
  async function computeParts() {
    resetWorkerState();
    updateAddCartButtonState(true);
    setMsg('', null);

    el.partsBody.innerHTML = '';
    if (el.cutPlan) el.cutPlan.innerHTML = '';
    updateResultsVisibility();
    updateConfidenceUI();
    updateCutPlanToggleUI();

    if (!state.segments.length) {
      clearConfigAlert();
      el.summary.textContent = 'Start met tekenen van uw railplan.';
      updateAddCartButtonState(true);
      renderPartsPlaceholder('—');
      return;
    }
    if (hasRailValidationError()) {
      if (root) root.classList.remove('railcfg--results-ready');
      const msg = getRailValidationMessage();
      setConfigAlert(msg);
      el.summary.textContent = msg;
      updateAddCartButtonState(true);
      renderPartsPlaceholder('Begin opnieuw met tekenen.');
      return;
    }
    if (!state.color) {
      setConfigAlert('Kies eerst een railkleur om verder te gaan.');
      el.summary.textContent = 'Kies eerst een railkleur.';
      updateAddCartButtonState(true);
      renderPartsPlaceholder('Kies eerst een railkleur.');
      return;
    }
    if (!WORKER_BASE) {
      if (root) root.classList.remove('railcfg--results-ready');
      setConfigAlert('De configurator is nog niet volledig ingesteld. Neem contact met ons op als dit probleem zichtbaar blijft.');
      el.summary.textContent = 'Worker URL ontbreekt (vul in bij section settings).';
      updateAddCartButtonState(true);
      renderPartsPlaceholder('—');
      return;
    }

    if (!state.powerKey) {
      if (root) root.classList.remove('railcfg--results-ready');
      setConfigAlert('Kies eerst het stroompunt voordat de complete set kan worden berekend.');
      el.summary.textContent = 'Plaats eerst de voeding op het gewenste punt.';
      updateAddCartButtonState(true);
      renderPartsPlaceholder('Plaats eerst de voeding op het gewenste punt.');
      return;
    }

    if (!state.measureMode) {
      if (root) root.classList.remove('railcfg--results-ready');
      setConfigAlert('Kies eerst of u hartmaten of railmaten wilt gebruiken.');
      el.summary.textContent = 'Kies eerst of u met hartmaten of railmaten werkt.';
      updateAddCartButtonState(true);
      renderPartsPlaceholder('Kies eerst uw meetmethode.');
      return;
    }

    if (state.segmentLenCm.size !== state.segments.length) {
      if (root) root.classList.remove('railcfg--results-ready');
      setConfigAlert('Vul eerst alle rechte railmaten in om uw complete railset te berekenen.');
      el.summary.textContent = 'Vul nu alle rechte railmaten in voor de complete berekening.';
      updateAddCartButtonState(true);
      renderPartsPlaceholder('Vul nu alle maten in.');
      return;
    }

    const mySeq = ++workerSeq;
    clearConfigAlert();
    updateAddCartButtonState(true);
    el.summary.textContent = 'Uw complete railset wordt berekend…';
    renderPartsPlaceholder('Onderdelen worden berekend…');

    try {
      const out = await computeViaWorker();
      if (mySeq !== workerSeq) return;

      state.lastWorkerOut = out;
      state.lastParts = new Map(Object.entries(out.parts || {}).map(([k, v]) => [k, Number(v) || 0]));

      const rails = out.rails || {};
      state.lenWarning = !!rails.lenWarning;
      state.lenWarningText = rails.lenWarningText || '';

      state.lastRailParts = new Map(Object.entries(rails.railParts || {}).map(([k, v]) => [k, Number(v) || 0]));
      state.binPlans = Array.isArray(rails.binPlans) ? rails.binPlans : null;

      el.summary.innerHTML = '';
      if (rails.enabled && state.lenWarning) {
        const warn = document.createElement('div');
        warn.style.color = '#b00020';
        warn.textContent = state.lenWarningText || 'Vul alle raillengtes in (cm) of laat alles leeg.';
        el.summary.appendChild(warn);
      } else {
        const ok = document.createElement('div');
        ok.style.color = '#116b2a';
        ok.textContent = '✔ Uw complete railset is klaar om te bestellen.';
        el.summary.appendChild(ok);
      }

      updateStripsUI();
      const groups = buildPartsGroups();

      if (root) root.classList.add('railcfg--results-ready');

      if (!groups.length) {
        renderPartsPlaceholder('Geen onderdelen gevonden.');
        updateResultsVisibility();
        updateAddCartButtonState(true);
        return;
      }

      renderPartsGroups(groups);
      renderCutPlan();
      updateResultsVisibility();
      updateConfidenceUI();
      updateCutPlanToggleUI();
      clearConfigAlert();
      updateAddCartButtonState(false);

    } catch (e) {
      if (mySeq !== workerSeq) return;
      if (root) root.classList.remove('railcfg--results-ready');
      setConfigAlert('Er is iets misgegaan bij het berekenen van uw configuratie. Probeer het opnieuw.');
      el.summary.textContent = 'Worker fout: ' + (e?.message || e);
      updateAddCartButtonState(true);
      renderPartsPlaceholder('Onderdelen konden niet worden geladen.');
      if (el.cutPlan) el.cutPlan.innerHTML = '';
      updateResultsVisibility();
      updateConfidenceUI();
      updateCutPlanToggleUI();
    }
  }

  // ---------------------------
  // SVG render
  // ---------------------------
  function clearSvgOnly() { while (el.svg.firstChild) el.svg.removeChild(el.svg.firstChild); }

  function drawGrid() {
    const w = 1000, h = 600;
    const step = SNAP_CM * unitPerCm();

    const g = document.createElementNS('http://www.w3.org/2000/svg', 'g');
    g.setAttribute('opacity', '0.22');

    for (let x = 0; x <= w; x += step) {
      const l = document.createElementNS('http://www.w3.org/2000/svg', 'line');
      l.setAttribute('x1', x); l.setAttribute('y1', 0);
      l.setAttribute('x2', x); l.setAttribute('y2', h);
      l.setAttribute('stroke', '#ddd'); l.setAttribute('stroke-width', '1');
      g.appendChild(l);
    }
    for (let y = 0; y <= h; y += step) {
      const l = document.createElementNS('http://www.w3.org/2000/svg', 'line');
      l.setAttribute('x1', 0); l.setAttribute('y1', y);
      l.setAttribute('x2', w); l.setAttribute('y2', y);
      l.setAttribute('stroke', '#ddd'); l.setAttribute('stroke-width', '1');
      g.appendChild(l);
    }
    el.svg.appendChild(g);
  }

  function drawSegments() {
    const g = document.createElementNS('http://www.w3.org/2000/svg', 'g');
    for (const seg of state.segments) {
      const l = document.createElementNS('http://www.w3.org/2000/svg', 'line');
      l.setAttribute('x1', seg.a.x); l.setAttribute('y1', seg.a.y);
      l.setAttribute('x2', seg.b.x); l.setAttribute('y2', seg.b.y);
      l.setAttribute('stroke', '#111');
      l.setAttribute('stroke-width', '10');
      l.setAttribute('stroke-linecap', 'round');
      g.appendChild(l);
    }
    el.svg.appendChild(g);
  }

function drawTag(g, x, y, text) {
  const isMobile = window.innerWidth <= 768;

  const fontSize = isMobile ? 18 : 14;
  const padX = isMobile ? 10 : 10;
  const padY = isMobile ? 6 : 6;
  const charW = fontSize * 0.62;

  const w = Math.max(isMobile ? 44 : 34, Math.ceil(text.length * charW + padX * 2));
  const h = Math.ceil(fontSize + padY * 2);

  const rect = document.createElementNS('http://www.w3.org/2000/svg', 'rect');
  rect.setAttribute('x', String(x - w / 2));
  rect.setAttribute('y', String(y - h / 2));
  rect.setAttribute('rx', isMobile ? '8' : '6');
  rect.setAttribute('ry', isMobile ? '8' : '6');
  rect.setAttribute('width', String(w));
  rect.setAttribute('height', String(h));
  rect.setAttribute('fill', '#ffffff');
  rect.setAttribute('fill-opacity', '0.92');
  rect.setAttribute('stroke', 'none');
  rect.setAttribute('filter', 'drop-shadow(0 1px 2px rgba(0,0,0,0.15))');

  const t = document.createElementNS('http://www.w3.org/2000/svg', 'text');
  t.setAttribute('x', String(x));
  t.setAttribute('y', String(y + (isMobile ? 6 : 4)));
  t.setAttribute('text-anchor', 'middle');
  t.setAttribute('font-family', 'Arial, sans-serif');
  t.setAttribute('font-size', String(fontSize));
  t.setAttribute('font-weight', isMobile ? '700' : '600');
  t.setAttribute('fill', '#111');
  t.textContent = text;

  g.appendChild(rect);
  g.appendChild(t);
}

  function drawSegmentIndexLabels() {
    if (!state.segments.length) return;
    const g = document.createElementNS('http://www.w3.org/2000/svg', 'g');
    state.segments.forEach((seg, i) => {
      const m = segmentMidpoint(seg);
      const o = segmentLabelOffset(seg);
      drawTag(g, m.x + o.ox, m.y + o.oy, `S${i + 1}`);
    });
    el.svg.appendChild(g);
  }

  function drawSegmentLengthLabels() {
    if (!allSegmentLengthsFilled()) return;

    const g = document.createElementNS('http://www.w3.org/2000/svg', 'g');
    for (const seg of state.segments) {
      const key = normSegKey(seg);
      const cm = getDisplayLengthMap().get(key);
      if (!(typeof cm === 'number' && isFinite(cm) && cm > 0)) continue;

      const m = segmentMidpoint(seg);
      const o = segmentLabelOffset(seg);
      drawTag(g, m.x + o.ox * 1.8, m.y + o.oy * 1.8, `${formatCmValue(cm)} cm`);
    }
    el.svg.appendChild(g);
  }

  function drawNodes() {
    const g = document.createElementNS('http://www.w3.org/2000/svg', 'g');

    for (const p of state.points) {
      const key = pointKey(p);

      const hit = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
      hit.setAttribute('cx', p.x);
      hit.setAttribute('cy', p.y);
      hit.setAttribute('r', '22');
      hit.setAttribute('fill', 'transparent');
      hit.setAttribute('data-node-key', key);
      hit.style.pointerEvents = 'all';

      const c = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
      c.setAttribute('cx', p.x);
      c.setAttribute('cy', p.y);
      c.setAttribute('r', '6');
      c.setAttribute('fill', '#fff');
      c.setAttribute('stroke', '#111');
      c.setAttribute('stroke-width', '2');
      c.setAttribute('data-node-key', key);
      c.style.pointerEvents = 'none';

      g.appendChild(hit);
      g.appendChild(c);
    }

    el.svg.appendChild(g);
  }

  function drawPowerMarker() {
    if (!state.powerKey) return;
    const [x, y] = state.powerKey.split(',').map(Number);

    const g = document.createElementNS('http://www.w3.org/2000/svg', 'g');

    const halo = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
    halo.setAttribute('cx', x); halo.setAttribute('cy', y);
    halo.setAttribute('r', '16');
    halo.setAttribute('fill', 'none');
    halo.setAttribute('stroke', '#111');
    halo.setAttribute('stroke-width', '3');
    halo.setAttribute('stroke-dasharray', '6 6');

    const dot = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
    dot.setAttribute('cx', x); dot.setAttribute('cy', y);
    dot.setAttribute('r', '7');
    dot.setAttribute('fill', '#111');

    g.appendChild(halo);
    g.appendChild(dot);
    el.svg.appendChild(g);
  }

  // ---------------------------
  // Graph building
  // ---------------------------
  function pushSeg(a, b) {
    if (samePoint(a, b)) return;
    if (!(a.x === b.x || a.y === b.y)) return;

    const exists = state.segments.some(s =>
      (samePoint(s.a, a) && samePoint(s.b, b)) || (samePoint(s.a, b) && samePoint(s.b, a))
    );
    if (exists) return;

    state.segments.push({ a, b });
  }

  function uniquePoints(points) {
    const m = new Map();
    points.forEach(p => m.set(`${p.x},${p.y}`, p));
    return Array.from(m.values());
  }

  function sortPointsOnSeg(points, seg) {
    const s = normSeg(seg);
    const pts = points.slice();
    if (s.ori === 'H') pts.sort((p, q) => p.x - q.x);
    else pts.sort((p, q) => p.y - q.y);
    return pts;
  }

  function isCollinearDegree2Node(nodeKeyStr, nodes) {
    const node = nodes.get(nodeKeyStr);
    if (!node || node.incident.length !== 2) return false;

    const d1 = node.incident[0].dir;
    const d2 = node.incident[1].dir;

    return (
      (d1 === 'N' && d2 === 'S') || (d1 === 'S' && d2 === 'N') ||
      (d1 === 'E' && d2 === 'W') || (d1 === 'W' && d2 === 'E')
    );
  }

  function buildNodeMapFromSegments(segments) {
    const nodes = new Map();

    function addNode(p) {
      const k = pointKey(p);
      if (!nodes.has(k)) nodes.set(k, { p, incident: [] });
      return nodes.get(k);
    }

    function dirOf(a, b) {
      if (a.x === b.x) return (b.y > a.y) ? 'S' : 'N';
      return (b.x > a.x) ? 'E' : 'W';
    }

    for (const seg of segments) {
      const na = addNode(seg.a);
      const nb = addNode(seg.b);
      na.incident.push({ dir: dirOf(seg.a, seg.b), other: pointKey(seg.b) });
      nb.incident.push({ dir: dirOf(seg.b, seg.a), other: pointKey(seg.a) });
    }

    return nodes;
  }

  function mergeRedundantStraightNodes() {
    let changed = true;

    while (changed) {
      changed = false;
      const nodes = buildNodeMapFromSegments(state.segments);

      for (const [key, node] of nodes.entries()) {
        // actieve middenvoeding nooit weg-mergen
       if (state.powerKey) {
  if (key === state.powerKey) continue;

  const node = nodes.get(key);
  if (node) {
    const touchesPower = node.incident.some(i => i.other === state.powerKey);
    if (touchesPower) continue;
  }
}

        if (!isCollinearDegree2Node(key, nodes)) continue;

        const otherA = parsePointKey(node.incident[0].other);
        const otherB = parsePointKey(node.incident[1].other);
        const self = parsePointKey(key);

        if (!otherA || !otherB || !self) continue;

        // zoek exact de 2 segmenten die op deze node aansluiten
        const hitIdx = [];
        for (let i = 0; i < state.segments.length; i++) {
          const s = state.segments[i];
          if (
            samePoint(s.a, self) || samePoint(s.b, self)
          ) {
            hitIdx.push(i);
          }
        }

        if (hitIdx.length !== 2) continue;

        const idxDesc = hitIdx.sort((a, b) => b - a);
        state.segments.splice(idxDesc[0], 1);
        state.segments.splice(idxDesc[1], 1);

        pushSeg(otherA, otherB);

        changed = true;
        break;
      }
    }
  }

  function parsePointKey(key) {
    const parts = String(key).split(',');
    if (parts.length !== 2) return null;

    const x = Number(parts[0]);
    const y = Number(parts[1]);

    if (!isFinite(x) || !isFinite(y)) return null;
    return { x, y };
  }

function parsePointKey(key) {
  const parts = String(key).split(',');
  if (parts.length !== 2) return null;
  const x = Number(parts[0]);
  const y = Number(parts[1]);
  if (!isFinite(x) || !isFinite(y)) return null;
  return { x, y };
}

function buildNodeMapFromSegments(segments) {
  const nodes = new Map();

  function addNode(p) {
    const k = pointKey(p);
    if (!nodes.has(k)) nodes.set(k, { p, incident: [] });
    return nodes.get(k);
  }

  function dirOf(a, b) {
    if (a.x === b.x) return (b.y > a.y) ? 'S' : 'N';
    return (b.x > a.x) ? 'E' : 'W';
  }

  for (const seg of segments) {
    const na = addNode(seg.a);
    const nb = addNode(seg.b);
    na.incident.push({ dir: dirOf(seg.a, seg.b), other: pointKey(seg.b) });
    nb.incident.push({ dir: dirOf(seg.b, seg.a), other: pointKey(seg.a) });
  }

  return nodes;
}

function isCollinearDegree2Node(nodeKeyStr, nodes) {
  const node = nodes.get(nodeKeyStr);
  if (!node || node.incident.length !== 2) return false;

  const d1 = node.incident[0].dir;
  const d2 = node.incident[1].dir;

  return (
    (d1 === 'N' && d2 === 'S') || (d1 === 'S' && d2 === 'N') ||
    (d1 === 'E' && d2 === 'W') || (d1 === 'W' && d2 === 'E')
  );
}

function mergeRedundantStraightNodes() {
  let changed = true;

  while (changed) {
    changed = false;
    const nodes = buildNodeMapFromSegments(state.segments);

    for (const [key, node] of nodes.entries()) {
      // actieve middenvoeding nooit weg-mergen
      if (state.powerKey && key === state.powerKey) continue;

      if (!isCollinearDegree2Node(key, nodes)) continue;

      const self = parsePointKey(key);
      const otherA = parsePointKey(node.incident[0].other);
      const otherB = parsePointKey(node.incident[1].other);

      if (!self || !otherA || !otherB) continue;

      const hitIdx = [];
      for (let i = 0; i < state.segments.length; i++) {
        const s = state.segments[i];
        if (samePoint(s.a, self) || samePoint(s.b, self)) hitIdx.push(i);
      }

      if (hitIdx.length !== 2) continue;

      const idxDesc = hitIdx.sort((a, b) => b - a);
      state.segments.splice(idxDesc[0], 1);
      state.segments.splice(idxDesc[1], 1);
      pushSeg(otherA, otherB);

      changed = true;
      break;
    }
  }
}

function rebuildPoints() {
  mergeRedundantStraightNodes();

  const pts = [];
  const add = (p) => { if (!pts.some(q => samePoint(p, q))) pts.push(p); };

  state.segments.forEach(s => { add(s.a); add(s.b); });
  state.points = pts;

  if (state.powerKey) {
    const exists = state.points.some(p => pointKey(p) === state.powerKey);
    if (!exists) state.powerKey = null;
  }

  pruneSegmentLenMap();
  recomputeDerivedLengthsFromMode();
  updateInvalidDrawingState();
}

function splitSegmentAtIndex(idx, p, opts = {}) {
  const seg = state.segments[idx];
  if (!seg) return false;
  if (samePoint(p, seg.a) || samePoint(p, seg.b)) return false;

  state.segments.splice(idx, 1);
  pushSeg(seg.a, p);
  pushSeg(p, seg.b);

  if (!opts.skipRebuild) rebuildPoints();
  return true;
}
function tryPickPowerOnSegment(evt) {
  const raw = svgPointFromEvent(evt);
  const p = { x: raw.x, y: raw.y };

  const THRESH = 14;
  let bestIdx = -1;
  let bestDist = Infinity;

  for (let i = 0; i < state.segments.length; i++) {
    const d = distPointToSeg(p, state.segments[i]);
    if (d < bestDist) {
      bestDist = d;
      bestIdx = i;
    }
  }

  if (bestIdx === -1 || bestDist > THRESH) return false;

  const q = closestPointOnSegSnapped(p, state.segments[bestIdx]);
  if (!onSegment(q, state.segments[bestIdx])) return false;

  const qKey = pointKey(q);

  // klik exact op bestaand punt
  if (state.points.some(pt => pointKey(pt) === qKey)) {
    state.powerKey = qKey;
    state.pickPowerMode = false;
    rebuildPoints();
    return true;
  }

  // eerst fysiek splitten, maar nog niet rebuilden
  if (!splitSegmentAtIndex(bestIdx, q, { skipRebuild: true })) return false;

  // nu pas de nieuwe node als actief stroompunt zetten
  state.powerKey = qKey;
  state.pickPowerMode = false;

  // daarna rebuilden, zodat deze node beschermd blijft
  rebuildPoints();
  setDesignCode(null);
  return true;
}

  function segIntersection(seg1, seg2) {
    const s1 = normSeg(seg1), s2 = normSeg(seg2);
    if (s1.ori === s2.ori) {
      const pts = [s1.a, s1.b];
      for (const p of pts) if (onSegment(p, seg2)) return { x: p.x, y: p.y };
      const pts2 = [s2.a, s2.b];
      for (const p of pts2) if (onSegment(p, seg1)) return { x: p.x, y: p.y };
      return null;
    }
    const h = (s1.ori === 'H') ? s1 : s2;
    const v = (s1.ori === 'V') ? s1 : s2;
    const p = { x: v.a.x, y: h.a.y };
    if (p.x >= h.a.x && p.x <= h.b.x && p.y >= v.a.y && p.y <= v.b.y) return p;
    return null;
  }

  function addSegment(a, b) {
    if (samePoint(a, b)) return;
    const newSeg = { a, b };

    let splitPointsNew = [a, b];
    const splitsForExisting = new Map();

    state.segments.forEach((seg, idx) => {
      const ip = segIntersection(newSeg, seg);
      if (!ip) return;
      splitPointsNew.push(ip);
      if (onSegment(ip, seg)) {
        if (!splitsForExisting.has(idx)) splitsForExisting.set(idx, []);
        splitsForExisting.get(idx).push(ip);
      }
    });

    splitPointsNew = uniquePoints(splitPointsNew);

    const indices = Array.from(splitsForExisting.keys()).sort((x, y) => y - x);
    indices.forEach(idx => {
      const seg = state.segments[idx];
      let pts = uniquePoints(splitsForExisting.get(idx) || []);
      const endpoints = [seg.a, seg.b];
      pts = pts.filter(p => !endpoints.some(e => samePoint(e, p)));
      if (!pts.length) return;

      state.segments.splice(idx, 1);

      const allPts = uniquePoints([seg.a, seg.b, ...pts]);
      const ordered = sortPointsOnSeg(allPts, seg);
      for (let i = 0; i < ordered.length - 1; i++) pushSeg(ordered[i], ordered[i + 1]);
    });

    const orderedNew = sortPointsOnSeg(splitPointsNew, newSeg);
    for (let i = 0; i < orderedNew.length - 1; i++) pushSeg(orderedNew[i], orderedNew[i + 1]);

    rebuildPoints();
    setDesignCode(null);
  }

  // ---------------------------
  // Segment length table
  // ---------------------------
  function renderSegmentTable() {
    if (!el.segTableBody) return;

    pruneSegmentLenMap();
    recomputeDerivedLengthsFromMode();
    el.segTableBody.innerHTML = '';

    if (!state.segments.length) {
      const tr = document.createElement('tr');
      tr.innerHTML = `<td colspan="3" style="color:#666;font-size:12px;padding:8px 6px">Teken eerst segmenten.</td>`;
      el.segTableBody.appendChild(tr);
      return;
    }

    state.segments.forEach((seg, i) => {
      const key = normSegKey(seg);
      const railVal = state.segmentLenCm.get(key);
      const hartVal = state.centerLenCm.get(key);
      const hasMode = !!state.measureMode;
      const isRailMode = state.measureMode === 'rail';
      const isHartMode = state.measureMode === 'hart';

      const tr = document.createElement('tr');
      tr.innerHTML = `
        <td>S${i + 1}</td>
        <td>
          <input class="railcfg__segInput ${isRailMode ? '' : 'is-readonly'}" inputmode="decimal" pattern="[0-9]+([\.,][0-9])?"
                 placeholder="${hasMode ? '(vul hier de lengte in CM in)' : 'Kies eerst'}" data-segkey="${key}" data-len-type="rail" ${isRailMode ? '' : 'disabled tabindex="-1" aria-disabled="true"'} value="${formatCmValue(railVal)}">
        </td>
        <td>
          <input class="railcfg__segInput ${isHartMode ? '' : 'is-readonly'}" inputmode="decimal" pattern="[0-9]+([\.,][0-9])?"
                 placeholder="${hasMode ? '(Vul hier de lengte in CM in)' : 'Kies eerst'}" data-segkey="${key}" data-len-type="hart" ${isHartMode ? '' : 'disabled tabindex="-1" aria-disabled="true"'} value="${formatCmValue(hartVal)}">
        </td>
      `;
      el.segTableBody.appendChild(tr);
    });

    const activeInputs = Array.from(
      el.segTableBody.querySelectorAll('input[data-segkey]:not(:disabled)')
    );

    function focusNextActiveInput(currentInput, direction) {
      const idx = activeInputs.indexOf(currentInput);
      if (idx === -1) return false;

      const next = activeInputs[idx + direction];
      if (!next) return false;

      try {
        next.focus();
        next.select();
      } catch (e) {}
      return true;
    }

    activeInputs.forEach((inp) => {
      inp.addEventListener('focus', () => {
        window.requestAnimationFrame(() => {
          try { inp.select(); } catch (e) {}
        });
      });

      inp.addEventListener('click', () => {
        if (document.activeElement !== inp) return;
        try { inp.select(); } catch (e) {}
      });

      inp.addEventListener('input', () => {
        const key = inp.getAttribute('data-segkey');
        const type = inp.getAttribute('data-len-type');
        const raw = String(inp.value || '').trim();

        if (type === 'rail') {
          if (!raw) state.segmentLenCm.delete(key);
          else {
            const n = parseCmInput(raw);
            if (n != null) state.segmentLenCm.set(key, n);
            else state.segmentLenCm.delete(key);
          }
        } else {
          if (!raw) state.centerLenCm.delete(key);
          else {
            const n = parseCmInput(raw);
            if (n != null) state.centerLenCm.set(key, n);
            else state.centerLenCm.delete(key);
          }
        }

        recomputeDerivedLengthsFromMode();
        setDesignCode(null);
        scheduleComputeParts();

        if (el.railsBlock && el.railsToggle) {
          if (countEnteredLengths() > 0) setRailsBlock(true);
          else setRailsBlock(false);
        }
        updateRailsToggleState();
      });

      inp.addEventListener('blur', render);
      inp.addEventListener('keydown', (e) => {
        if (e.key === 'Enter') {
          e.preventDefault();
          if (!focusNextActiveInput(inp, 1)) inp.blur();
          return;
        }

        if (e.key === 'Tab') {
          const moved = focusNextActiveInput(inp, e.shiftKey ? -1 : 1);
          if (moved) e.preventDefault();
        }
      });
    });

    updateMeasureModeUI();
  }

  function syncButtons() {
    const hasAny = state.segments.length > 0;
    const locked = !!state.isLocked;

    // Pick power
    el.btnPickPower.forEach((btn) => {
      btn.disabled = !hasAny;
      if (state.pickPowerMode) btn.textContent = 'Klik punt/segment…';
      else if (btn.dataset.defaultLabel) btn.textContent = btn.dataset.defaultLabel;
    });

    // Clear power
    el.btnClearPower.forEach((btn) => {
      btn.disabled = !state.powerKey;
    });

    // Lock buttons
    el.btnLocks.forEach((btn) => {
      const isLocked = !!state.isLocked;
      btn.classList.toggle('is-locked', isLocked);
      btn.classList.toggle('is-unlocked', !isLocked);
      if (!btn.querySelector('.lock-icon')) {
        btn.innerHTML = '<span class="lock-icon"></span>';
      }
      btn.setAttribute('aria-label', isLocked ? 'Ontwerp vergrendeld' : 'Ontwerp bewerkbaar');
      btn.setAttribute('title', isLocked ? 'Ontwerp vergrendeld' : 'Ontwerp bewerkbaar');
    });

    // Klaar met tekenen buttons
    el.btnFinishDraw.forEach((btn) => {
      btn.disabled = !hasAny || hasRailValidationError();
      btn.classList.toggle('is-locked', locked);
    });

    // Sidebar power status
    if (el.powerStatus) {
      el.powerStatus.textContent = state.powerKey ? 'Gekozen' : 'Niet gekozen';
    }
  }

  function updateCanvasStatus() {
    if (!el.statusText) return;

    if (hasRailValidationError() && state.segments.length) {
      el.statusText.textContent = getRailValidationMessage();
      return;
    }

    if (!state.segments.length) {
      el.statusText.textContent = 'Klik om te starten — teken het bovenaanzicht horizontaal of verticaal';
      return;
    }
    if (!state.color) {
      el.statusText.textContent = state.isLocked
        ? 'Tekening vergrendeld — kies nu uw railkleur'
        : 'Tekening gereed — kies nu uw railkleur';
      return;
    }
    if (state.pickPowerMode) {
      el.statusText.textContent = 'Plaats het stroompunt — klik op een eindpunt of rechte rail';
      return;
    }
    if (!state.powerKey) {
      el.statusText.textContent = 'Railkleur gekozen — plaats nu het stroompunt (scroll naar stap 3)';
      return;
    }
    if (!state.measureMode) {
      el.statusText.textContent = 'Stroompunt geplaatst — kies nu eerst hartmaat of railmaat in stap 4';
      return;
    }
    if (state.segmentLenCm.size !== state.segments.length) {
      el.statusText.textContent = 'Stroompunt geplaatst — vul nu alle maten in (scroll naar stap 4)';
      return;
    }

    el.statusText.textContent = '✔ Ontwerp compleet — alle onderdelen zijn correct bepaald';
  }

  function updateStepStates() {
    if (!el.stepItems || !el.stepItems.length) return;

    const step1Done = !!state.color;
    const step2Done = state.segments.length > 0;
    const step3Done = !!state.powerKey;
    const step4Done = state.segments.length > 0 && !!state.measureMode && state.segmentLenCm.size === state.segments.length;
    const step5Done = Array.from(state.spotQtyByVariant.values()).some((qty) => clampSpotQty(qty) > 0);

    el.stepItems.forEach((item) => {
      const idx = Number(item.getAttribute('data-step-index') || 0);
      item.classList.remove('railcfg__step--todo', 'railcfg__step--active', 'railcfg__step--done');

      const isDone =
        (idx === 1 && step1Done) ||
        (idx === 2 && step2Done) ||
        (idx === 3 && step3Done) ||
        (idx === 4 && step4Done) ||
        (idx === 5 && step5Done);

      let isActive = false;
      if (!step1Done && idx === 1) isActive = true;
      else if (step1Done && !step2Done && idx === 2) isActive = true;
      else if (step2Done && !step3Done && idx === 3) isActive = true;
      else if (step3Done && !step4Done && idx === 4) isActive = true;
      else if (step4Done && !step5Done && idx === 5) isActive = true;

      if (isDone && !isActive) item.classList.add('railcfg__step--done');
      else if (isActive) item.classList.add('railcfg__step--active');
      else item.classList.add('railcfg__step--todo');
    });
  }

  function render() {
    clearSvgOnly();
    drawGrid();
    drawSegments();
    drawSegmentIndexLabels();
    drawNodes();
    drawPowerMarker();
    drawSegmentLengthLabels();
    renderSegmentTable();
    updateColorUI();
    updateStripsUI();
    updateSpotsUI();
    updateAccessoriesUI();
    updateMeasureModeUI();
    syncButtons();
    updateLockUI();
    updateCanvasStatus();
    syncRailValidationAlert();
    updateStepStates();
    updateResultsVisibility();
    updateConfidenceUI();
    updateCutPlanToggleUI();
    updateAddCartButtonState(false);
    scheduleComputeParts();
    scheduleShareUpdate();
    updateRailsToggleState();
    saveAutosave();
  }

  // ---------------------------
  // Drawing interactions
  // ---------------------------
  const drawing = { active: false, start: null, previewLine: null };

  function startPreview(a) {
    const l = document.createElementNS('http://www.w3.org/2000/svg', 'line');
    l.setAttribute('x1', a.x); l.setAttribute('y1', a.y);
    l.setAttribute('x2', a.x); l.setAttribute('y2', a.y);
    l.setAttribute('stroke', '#666');
    l.setAttribute('stroke-width', '6');
    l.setAttribute('stroke-linecap', 'round');
    l.setAttribute('stroke-dasharray', '10 8');
    el.svg.appendChild(l);
    drawing.previewLine = l;
  }

  function updatePreview(to) {
    if (!drawing.previewLine || !drawing.start) return;
    const seg = normalizeSegment(drawing.start, to);
    drawing.previewLine.setAttribute('x2', seg.b.x);
    drawing.previewLine.setAttribute('y2', seg.b.y);
  }

  function stopPreview() {
    if (drawing.previewLine) {
      drawing.previewLine.remove();
      drawing.previewLine = null;
    }
  }

  function onPointerDown(evt) {
    evt.preventDefault();

    if (state.pickPowerMode) {
      const elNode = evt.target && evt.target.closest ? evt.target.closest('[data-node-key]') : null;
      const key = elNode ? elNode.getAttribute('data-node-key') : null;

if (key) {
  state.powerKey = key;
  state.pickPowerMode = false;
  rebuildPoints();
  setDesignCode(null);
  render();
  return;
}

      if (tryPickPowerOnSegment(evt)) render();
      return;
    }

    if (!isEditable()) return;

    const p0 = svgPointFromEvent(evt);
    const p = { x: snap(p0.x), y: snap(p0.y) };

    if (!drawing.active) {
  clearConfigAlert();
  // Leeg ontwerp: eerste lijn mag overal starten
  if (!state.segments.length) {
    drawing.active = true;
    drawing.start = p;
    startPreview(p);
    if (!state.points.some(q => samePoint(p, q))) state.points.push(p);
    render();
    return;
  }

  // Bestaand ontwerp: alleen starten vanaf bestaand punt
  const existingPoint = state.points.find(q => samePoint(q, p));
  if (!existingPoint) {
    setConfigAlert('Wilt u verder tekenen? Klik dan op een bestaand eindpunt van het bovenaanzicht.');
    setMsg('Wilt u verder tekenen? Klik dan op een bestaand eindpunt van het bovenaanzicht.', 'err');
    return;
  }

  drawing.active = true;
  drawing.start = existingPoint;
  startPreview(existingPoint);
  render();
  return;
}

    const seg = normalizeSegment(drawing.start, p);
    addSegment(seg.a, seg.b);

    drawing.start = seg.b;
    stopPreview();
    startPreview(drawing.start);

    render();
  }

  function onPointerMove(evt) {
    if (!isEditable()) return;
    if (!drawing.active || state.pickPowerMode) return;
    const p0 = svgPointFromEvent(evt);
    const p = { x: snap(p0.x), y: snap(p0.y) };
    updatePreview(p);
  }

  function undo() {
    if (!state.segments.length) return;

    state.segments.pop();
    rebuildPoints();
    setDesignCode(null);

    if (!state.segments.length) {
      drawing.active = false;
      drawing.start = null;
      stopPreview();
      state.powerKey = null;
      state.pickPowerMode = false;
      state.segmentLenCm.clear();
      state.centerLenCm.clear();
    }
    render();
  }

  function clearAll() {
    clearConfigAlert();
    state.points = [];
    state.segments = [];
    state.powerKey = null;
    state.pickPowerMode = false;
    state.color = null;
    state.designCode = null;
    state.isLocked = false;
    drawing.active = false;
    drawing.start = null;
    stopPreview();
    state.segmentLenCm.clear();
    state.centerLenCm.clear();
    state.spotQtyByVariant.clear();
    state.addStrips = false;
    state.cutPlanOpen = false;
    resetWorkerState();
    if (el.addStrips) el.addStrips.checked = false;
    setMsg('', null);
    setDesignMsg('', null);
    setDesignCode(null);
    clearAutosave();
    render();
  }

  // ---------------------------
  // Add to cart (rails per bin met zaagmaat)
  // ---------------------------
  function partsToCartItems() {
    if (!state.lastParts) return { ok: false, reason: 'Geen onderdelen om toe te voegen.' };

    const map = VARIANTS[state.color];
    if (!map) return { ok: false, reason: 'Kleurmapping ontbreekt.' };

    const railItems = [];
    const stripItems = [];
    const otherItems = [];

    function makeItem(code, qty, properties) {
      if (!qty || qty <= 0) return { ok: true, item: null };
      const variantId = map[code];
      if (!variantId) {
        return {
          ok: false,
          reason: `Geen Variant ID gevonden voor ${code} (${state.color}).`
        };
      }

      const obj = { id: variantId, quantity: qty };
      const mergedProps = Object.assign({}, properties || {});
      if (state.designCode) mergedProps.Ontwerpcode = state.designCode;
      if (Object.keys(mergedProps).length) obj.properties = mergedProps;
      return { ok: true, item: obj };
    }

    function pushTo(list, code, qty, properties) {
      const result = makeItem(code, qty, properties);
      if (!result.ok) return result;
      if (result.item) list.push(result.item);
      return { ok: true };
    }

    function buildGroupedRailCutLabel(cutsStr, qty) {
      const safeQty = Math.max(1, Number(qty) || 1);
      const raw = String(cutsStr || '').trim();
      if (!raw) return '';
      if (safeQty === 1) return raw;
      if (raw === 'Hele rail (niet zagen)') return raw;

      const parts = raw
        .split('|')
        .map((part) => String(part || '').trim())
        .filter(Boolean)
        .map((part) => {
          const match = part.match(/^(\d+)x\s+(.+)$/i);
          if (!match) return part;
          const baseQty = Number(match[1]) || 0;
          const label = String(match[2] || '').trim();
          if (!baseQty || !label) return part;
          return `${baseQty * safeQty}x ${label}`;
        });

      return parts.join(' | ');
    }

    // Rails apart verzamelen zodat ze zichtbaar bovenaan in de cart komen.
    if (state.binPlans && !state.lenWarning) {
      const groupedRails = new Map();

      for (const b of state.binPlans) {
        const code = String(b.code || '').trim();
        const cutsStr = String(b.cutsStr || '').trim();
        const groupKey = `${code}__${cutsStr}`;

        if (!groupedRails.has(groupKey)) {
          groupedRails.set(groupKey, { code, cutsStr, qty: 0 });
        }

        groupedRails.get(groupKey).qty += 1;
      }

      for (const group of groupedRails.values()) {
        const properties = {};
        const groupedCutLabel = buildGroupedRailCutLabel(group.cutsStr, group.qty);
        if (groupedCutLabel) properties.zaagmaat = groupedCutLabel;

        const result = pushTo(railItems, group.code, group.qty, properties);
        if (!result.ok) return result;
      }
    }

    // Afdekstrips direct na de rails tonen.
    for (const [code, qty] of getStripParts().entries()) {
      const result = pushTo(stripItems, code, qty);
      if (!result.ok) return result;
    }

    // Overige configurator-onderdelen.
    for (const code of ['GB11', 'GB12', 'GB14']) {
      const result = pushTo(otherItems, code, state.lastParts.get(code) || 0);
      if (!result.ok) return result;
    }

    for (const code of ['GB34', 'GB35', 'GB36', 'GB37', 'GB39', 'GB40', 'GB38']) {
      const result = pushTo(otherItems, code, state.lastParts.get(code) || 0);
      if (!result.ok) return result;
    }

    if (state.lastRailParts && !state.lenWarning) {
      const result = pushTo(otherItems, 'GB21', state.lastRailParts.get('GB21') || 0);
      if (!result.ok) return result;
    }

    {
      const result = pushTo(otherItems, 'GB41', state.lastParts.get('GB41') || 0);
      if (!result.ok) return result;
    }

    const visibleItems = [
      ...railItems,
      ...stripItems,
      ...otherItems
    ];

    if (!visibleItems.length) return { ok: false, reason: 'Geen onderdelen om toe te voegen.' };

    // Shopify toont nieuw toegevoegde regels bovenaan.
    // Daarom sturen we de configurator-items in omgekeerde volgorde,
    // zodat de zichtbare volgorde in de cart wordt:
    // 1. rails
    // 2. afdekstrips
    // 3. overige configurator-onderdelen
    return { ok: true, items: visibleItems.slice().reverse() };
  }

  async function addToCart(items) {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items })
    });
    if (!res.ok) {
      let txt = '';
      try { txt = await res.text(); } catch (e) {}
      throw new Error('Cart add failed: ' + (txt || res.status));
    }
    return await res.json();
  }

  async function handleAddCartClick() {
    setMsg('', null);

    if (hasRailValidationError()) {
      const msg = getRailValidationMessage();
      setMsg(msg, 'err');
      setConfigAlert(msg);
      updateCanvasStatus();
      return;
    }
    if (!state.color) {
      setConfigAlert('Kies eerst een railkleur om verder te gaan.');
      return;
    }
    if (!state.powerKey) {
      setConfigAlert('Kies eerst het stroompunt voordat u de complete set kunt toevoegen.');
      return;
    }
    if (!state.measureMode) {
      setConfigAlert('Kies eerst of u hartmaten of railmaten wilt gebruiken.');
      return;
    }
    if (state.segmentLenCm.size !== state.segments.length) {
      setConfigAlert('Vul eerst alle rechte railmaten in voordat u de complete set kunt toevoegen.');
      return;
    }

    clearConfigAlert();
    updateAddCartButtonState(true);
    setTextAll(el.btnAddCart, 'Bezig…');

    try {
      if (!state.designCode) {
        const saved = await saveDesignOnServer();
        setDesignCode(saved.code);
      }

      await trackRailcfgEvent('add_to_cart_click', null, { waitForResponse: true });

      const pack = partsToCartItems();
      if (!pack.ok) throw new Error(pack.reason || 'Geen onderdelen om toe te voegen.');

      const items = pack.items.slice();
      const spotItems = getSpotCartItems();
      if (spotItems.length) items.unshift(...spotItems.slice().reverse());

      await addToCart(items);

      if (state.designCode) {
        await setCartAttributes({ Ontwerpcode: state.designCode });
      }

      const spotMsg = spotItems.length ? ` Inclusief ${spotItems.length} spotregel${spotItems.length === 1 ? '' : 's'}.` : '';
      setMsg(`Onderdelen zijn toegevoegd aan uw winkelmand. Ontwerpcode: ${state.designCode || '—'}.${spotMsg}`, 'ok');

      window.setTimeout(() => {
        window.location.href = '/cart';
      }, 450);
      return;

    } catch (err) {
      setMsg(err?.message || 'Toevoegen mislukt. Probeer opnieuw of neem contact op.', 'err');
      updateAddCartButtonState(false);
      console.error(err);
    }
  }

  el.btnAddCart.forEach((b) => b.addEventListener('click', handleAddCartClick));

  // ---------------------------
  // Export PDF (download via Worker /export-pdf)
  // ---------------------------
  if (el.btnExportPdf) {
    el.btnExportPdf.addEventListener('click', async () => {
      try {
        if (hasRailValidationError()) throw new Error(getRailValidationMessage());
        if (!state.segments.length) throw new Error('Teken eerst een railvorm.');
        if (!state.color) throw new Error('Kies eerst een railkleur voordat u de installatietekening downloadt.');
        if (!state.powerKey) throw new Error('Kies eerst het stroompunt voordat u de installatietekening downloadt.');
        if (!state.measureMode) throw new Error('Kies eerst of u hartmaten of railmaten wilt gebruiken.');
        if (state.segmentLenCm.size !== state.segments.length) throw new Error('Vul eerst alle rechte railmaten in voordat u de installatietekening downloadt.');
        if (!WORKER_BASE) throw new Error('Worker URL ontbreekt (section setting).');

        clearConfigAlert();
        el.btnExportPdf.disabled = true;
        const oldText = el.btnExportPdf.dataset.defaultLabel || el.btnExportPdf.textContent;
        el.btnExportPdf.textContent = 'PDF maken…';

        if (!state.designCode) {
          setDesignMsg('Ontwerpcode wordt aangemaakt…', 'ok');
          const saved = await saveDesignOnServer();
          setDesignCode(saved.code);
        }

        await trackRailcfgEvent('pdf_click', { designCode: state.designCode || null }, { waitForResponse: true });

        const segLenObj = {};
        for (const [k, v] of state.segmentLenCm.entries()) segLenObj[k] = v;

        const centerLenObj = {};
        for (const [k, v] of state.centerLenCm.entries()) centerLenObj[k] = v;

        const payload = {
          color: state.color,
          powerKey: state.powerKey,
          segments: state.segments,
          measureMode: state.measureMode,
          segmentLenCm: segLenObj,
          centerLenCm: centerLenObj,
          designCode: state.designCode || null,
          addStrips: !!state.addStrips,
          spotSelections: buildSpotSelectionsObject(),
          spotItems: buildSpotItemsForPdf()
        };

        const res = await fetch(WORKER_BASE + '/export-pdf', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload)
        });

        if (!res.ok) {
          const out = await res.json().catch(() => ({}));
          throw new Error(out?.reason || `Export mislukt (${res.status}).`);
        }

        const blob = await res.blob();
        const url = URL.createObjectURL(blob);

        const a = document.createElement('a');
        a.href = url;
        a.download = 'railspot-installatietekening.pdf';
        document.body.appendChild(a);
        a.click();
        a.remove();

        window.setTimeout(() => URL.revokeObjectURL(url), 1500);
        setDesignMsg(`Installatietekening gedownload. Ontwerpcode: ${state.designCode || '—'}.`, 'ok');
        el.btnExportPdf.textContent = oldText;
        el.btnExportPdf.disabled = false;

      } catch (e) {
        if (el.btnExportPdf) {
          el.btnExportPdf.disabled = false;
          el.btnExportPdf.textContent = el.btnExportPdf.dataset.defaultLabel || 'PDF';
        }
        setConfigAlert(e?.message || 'Export mislukt.');
      }
    });
  }

  // ---------------------------
  // Color buttons
  // ---------------------------
  function setColor(next) {
    if (!(next in VARIANTS)) return;
    const prev = state.color;
    state.color = next;
    setDesignCode(null);

    if (prev && prev !== next) {
      state.spotQtyByVariant.clear();
    }

    el.colorBtns.forEach(b => b.classList.toggle('is-active', b.getAttribute('data-color') === next));
    updateColorIndicatorPill();

    if (!hasRailValidationError()) clearConfigAlert();
    render();
  }
  el.colorBtns.forEach(b => b.addEventListener('click', () => setColor(b.getAttribute('data-color'))));

  // ---------------------------
  // Bindings (multi buttons)
  // ---------------------------
  el.svg.addEventListener('pointerdown', onPointerDown);
  el.svg.addEventListener('pointermove', onPointerMove);

  el.btnUndo.forEach((b) => b.addEventListener('click', undo));
  el.btnClear.forEach((b) => b.addEventListener('click', clearAll));

  bindPress(el.btnLocks, () => {
    state.isLocked = !state.isLocked;
    if (state.isLocked) {
      drawing.active = false;
      drawing.start = null;
      stopPreview();
      state.pickPowerMode = false;
    }
    render();
  });

  bindPress(el.btnFinishDraw, () => {
    finishDrawingAndAdvance();
  });

  el.btnPickPower.forEach((b) => b.addEventListener('click', () => {
    if (!state.segments.length) return;
    state.pickPowerMode = true;
    render();
    window.setTimeout(() => {
      scrollToDrawStep();
    }, 60);
  }));

el.btnClearPower.forEach((b) => b.addEventListener('click', () => {
  state.powerKey = null;
  state.pickPowerMode = false;
  rebuildPoints();
  setDesignCode(null);
  render();
}));

  if (el.measureModeRadios && el.measureModeRadios.length) {
    el.measureModeRadios.forEach((radio) => {
      radio.addEventListener('change', () => {
        if (!radio.checked) return;
        setMeasureMode(radio.value);
      });
    });
  }

  if (el.btnLoadDesign) {
    el.btnLoadDesign.addEventListener('click', handleManualLoadDesign);
  }

  if (el.btnSaveDesign) {
    el.btnSaveDesign.addEventListener('click', handleSaveDesignOnly);
  }

  if (el.designCodeInput) {
    el.designCodeInput.addEventListener('input', () => {
      const normalized = normalizeDesignCode(el.designCodeInput.value);
      if (el.designCodeInput.value !== normalized) {
        el.designCodeInput.value = normalized;
      }
    });

    el.designCodeInput.addEventListener('keydown', (evt) => {
      if (evt.key === 'Enter') {
        evt.preventDefault();
        handleManualLoadDesign();
      }
    });
  }

  // E-mail ontwerp knop binding
  if (el.btnShareLink) {
    el.btnShareLink.addEventListener('click', async () => {
      if (!state.segments.length) {
        setDesignMsg('Teken eerst een ontwerp om per e-mail te kunnen versturen.', 'err');
        return;
      }

      try {
        el.btnShareLink.disabled = true;
        el.btnShareLink.textContent = 'E-mail maken…';
        await emailDesignLink();
      } catch (err) {
        setDesignMsg(err?.message || 'E-mail link maken mislukt.', 'err');
      } finally {
        el.btnShareLink.disabled = false;
        el.btnShareLink.textContent = el.btnShareLink.dataset.defaultLabel || 'E-mail ontwerp';
      }
    });
  }

  if (el.btnOffer) {
    if (!el.btnOffer.dataset.defaultLabel) {
      el.btnOffer.dataset.defaultLabel = (el.btnOffer.textContent || '').trim() || 'Vraag over uw ontwerp?';
    }

    el.btnOffer.addEventListener('click', async () => {
      const isOpen = !!(el.offerPanel && !el.offerPanel.hidden);
      if (isOpen) {
        setOfferPanelOpen(false);
        setOfferFormMsg('', 'ok');
        return;
      }

      try {
        el.btnOffer.disabled = true;
        el.btnOffer.textContent = 'Even geduld…';
        await ensureOfferDesignCode();
        await trackRailcfgEvent('offer_open_click', { designCode: state.designCode || null }, { waitForResponse: true });
        setOfferPanelOpen(true);
      } catch (err) {
        setOfferFormMsg(err?.message || 'Er ging iets mis bij het voorbereiden van uw bericht.', 'err');
        setOfferPanelOpen(true);
      } finally {
        el.btnOffer.disabled = false;
        el.btnOffer.textContent = el.btnOffer.dataset.defaultLabel || 'Vraag over uw ontwerp?';
      }
    });
  }

  if (el.offerForm) {
    el.offerForm.addEventListener('submit', () => {
      syncOfferFormDesignData();
    });
  }

  if (el.cutPlanToggle) {
    el.cutPlanToggle.addEventListener('click', () => {
      state.cutPlanOpen = !state.cutPlanOpen;
      updateCutPlanToggleUI();
    });
  }

  bindSpotCarousel();
  bindAccessoryCarousel();

  if (el.addStrips) {
    el.addStrips.checked = !!state.addStrips;
    el.addStrips.addEventListener('change', () => {
      state.addStrips = !!el.addStrips.checked;
      setDesignCode(null);
      render();
    });
  }

  // ---------------------------
  // Init
  // ---------------------------
  updateColorUI();
  updateAddCartButtonState(true);
  setDesignCode(null);
  loadAccessorySelections();

  (async () => {
    try {
      const loadedDesign = await tryLoadDesignFromUrl();
      if (!loadedDesign) {
        const loadedCfg = tryLoadCfgFromUrl();
        if (!loadedCfg) {
          const restored = loadAutosave();
          if (restored) setDesignMsg('Uw vorige ontwerp is automatisch hersteld.', 'ok');
        }
      }
    } catch (e) {
      setDesignMsg(e?.message || 'Kon opgeslagen ontwerp niet laden.', 'err');
    }
    if (el.addStrips) el.addStrips.checked = !!state.addStrips;
    render();
  })();
})();
